//#region ../../node_modules/.pnpm/graphql@16.12.0/node_modules/graphql/jsutils/isObjectLike.mjs
function e(e) {
	return typeof e == "object" && !!e;
}
//#endregion
//#region ../../node_modules/.pnpm/graphql@16.12.0/node_modules/graphql/jsutils/invariant.mjs
function t(e, t) {
	if (!e) throw Error(t ?? "Unexpected invariant triggered.");
}
//#endregion
//#region ../../node_modules/.pnpm/graphql@16.12.0/node_modules/graphql/language/location.mjs
var n = /\r\n|[\n\r]/g;
function r(e, r) {
	let i = 0, a = 1;
	for (let o of e.body.matchAll(n)) {
		if (typeof o.index == "number" || t(!1), o.index >= r) break;
		i = o.index + o[0].length, a += 1;
	}
	return {
		line: a,
		column: r + 1 - i
	};
}
//#endregion
//#region ../../node_modules/.pnpm/graphql@16.12.0/node_modules/graphql/language/printLocation.mjs
function i(e) {
	return a(e.source, r(e.source, e.start));
}
function a(e, t) {
	let n = e.locationOffset.column - 1, r = "".padStart(n) + e.body, i = t.line - 1, a = e.locationOffset.line - 1, s = t.line + a, c = t.line === 1 ? n : 0, l = t.column + c, u = `${e.name}:${s}:${l}\n`, d = r.split(/\r\n|[\n\r]/g), f = d[i];
	if (f.length > 120) {
		let e = Math.floor(l / 80), t = l % 80, n = [];
		for (let e = 0; e < f.length; e += 80) n.push(f.slice(e, e + 80));
		return u + o([
			[`${s} |`, n[0]],
			...n.slice(1, e + 1).map((e) => ["|", e]),
			["|", "^".padStart(t)],
			["|", n[e + 1]]
		]);
	}
	return u + o([
		[`${s - 1} |`, d[i - 1]],
		[`${s} |`, f],
		["|", "^".padStart(l)],
		[`${s + 1} |`, d[i + 1]]
	]);
}
function o(e) {
	let t = e.filter(([e, t]) => t !== void 0), n = Math.max(...t.map(([e]) => e.length));
	return t.map(([e, t]) => e.padStart(n) + (t ? " " + t : "")).join("\n");
}
//#endregion
//#region ../../node_modules/.pnpm/graphql@16.12.0/node_modules/graphql/error/GraphQLError.mjs
function s(e) {
	let t = e[0];
	return t == null || "kind" in t || "length" in t ? {
		nodes: t,
		source: e[1],
		positions: e[2],
		path: e[3],
		originalError: e[4],
		extensions: e[5]
	} : t;
}
var c = class t extends Error {
	constructor(n, ...i) {
		let { nodes: a, source: o, positions: c, path: u, originalError: d, extensions: f } = s(i);
		super(n), this.name = "GraphQLError", this.path = u ?? void 0, this.originalError = d ?? void 0, this.nodes = l(Array.isArray(a) ? a : a ? [a] : void 0);
		let p = l(this.nodes?.map((e) => e.loc).filter((e) => e != null));
		this.source = o ?? p?.[0]?.source, this.positions = c ?? p?.map((e) => e.start), this.locations = c && o ? c.map((e) => r(o, e)) : p?.map((e) => r(e.source, e.start));
		let ee = e(d?.extensions) ? d?.extensions : void 0;
		/* c8 ignore start */
		this.extensions = f ?? ee ?? Object.create(null), Object.defineProperties(this, {
			message: {
				writable: !0,
				enumerable: !0
			},
			name: { enumerable: !1 },
			nodes: { enumerable: !1 },
			source: { enumerable: !1 },
			positions: { enumerable: !1 },
			originalError: { enumerable: !1 }
		}), d != null && d.stack ? Object.defineProperty(this, "stack", {
			value: d.stack,
			writable: !0,
			configurable: !0
		}) : Error.captureStackTrace ? Error.captureStackTrace(this, t) : Object.defineProperty(this, "stack", {
			value: Error().stack,
			writable: !0,
			configurable: !0
		});
		/* c8 ignore stop */
	}
	get [Symbol.toStringTag]() {
		return "GraphQLError";
	}
	toString() {
		let e = this.message;
		if (this.nodes) for (let t of this.nodes) t.loc && (e += "\n\n" + i(t.loc));
		else if (this.source && this.locations) for (let t of this.locations) e += "\n\n" + a(this.source, t);
		return e;
	}
	toJSON() {
		let e = { message: this.message };
		return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
	}
};
function l(e) {
	return e === void 0 || e.length === 0 ? void 0 : e;
}
//#endregion
//#region src/api-errors.ts
var u = {
	DT_PING: { message: "DT_PING" },
	ORGANIZATION_CONTENT: { message: "Content Error" },
	ORGANIZATION_MAX_LIMIT: { message: "Max Limit Error" },
	ORGANIZATION_UNKNOWN: { message: "Unknown Error" },
	ORGANIZATION_UNAUTHORIZED: { message: "Unauthorized Error" },
	ORGANIZATION_INVITATION_MAX_LIMIT: { message: "Max Limit Error" },
	ORGANIZATION_INVITATION_UNKNOWN: { message: "Unknown Error" },
	ORGANIZATION_INVITATION_UNAUTHORIZED: { message: "Unauthorized Error" },
	ORGANIZATION_INVITATION_EXPIRED: { message: "Expired Error" },
	ORGANIZATION_INVITATION_ACCEPTED: { message: "Accepted Error" },
	ORGANIZATION_INVITATION_EMAIL_MISMATCH: { message: "Email Mismatch Error" },
	ORGANIZATION_INVITATION_EMAIL_UNCONFIRMED: { message: "Email Unconfirmed Error" },
	STRIPE_NOT_CONFIGURED: { message: "contact admin" },
	STRIPE_ERROR: { message: "STRIPE_ERROR" },
	UNAUTHORIZED: { message: "UNAUTHORIZED" },
	UNIMPLEMENTED: { message: "UNIMPLEMENTED" },
	UNKNOWN: { message: "UNKNOWN" },
	MISSING_ARG: { message: "MISSING_ARG" },
	UNKNOWN_CCY: { message: "UNKNOWN_CCY" },
	MISSING_API_KEY_FOURSQUARE: { message: "MISSING_API_KEY_FOURSQUARE" }
};
function d(e) {
	let { code: t, messageOverride: n, debugInfo: r } = typeof e == "string" ? { code: e } : e;
	return new c(n || u[t].message, { extensions: {
		code: t,
		debugInfo: r,
		expose: !0
	} });
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/en-US/_lib/formatDistance.js
var f = {
	lessThanXSeconds: {
		one: "less than a second",
		other: "less than {{count}} seconds"
	},
	xSeconds: {
		one: "1 second",
		other: "{{count}} seconds"
	},
	halfAMinute: "half a minute",
	lessThanXMinutes: {
		one: "less than a minute",
		other: "less than {{count}} minutes"
	},
	xMinutes: {
		one: "1 minute",
		other: "{{count}} minutes"
	},
	aboutXHours: {
		one: "about 1 hour",
		other: "about {{count}} hours"
	},
	xHours: {
		one: "1 hour",
		other: "{{count}} hours"
	},
	xDays: {
		one: "1 day",
		other: "{{count}} days"
	},
	aboutXWeeks: {
		one: "about 1 week",
		other: "about {{count}} weeks"
	},
	xWeeks: {
		one: "1 week",
		other: "{{count}} weeks"
	},
	aboutXMonths: {
		one: "about 1 month",
		other: "about {{count}} months"
	},
	xMonths: {
		one: "1 month",
		other: "{{count}} months"
	},
	aboutXYears: {
		one: "about 1 year",
		other: "about {{count}} years"
	},
	xYears: {
		one: "1 year",
		other: "{{count}} years"
	},
	overXYears: {
		one: "over 1 year",
		other: "over {{count}} years"
	},
	almostXYears: {
		one: "almost 1 year",
		other: "almost {{count}} years"
	}
}, p = (e, t, n) => {
	let r, i = f[e];
	return r = typeof i == "string" ? i : t === 1 ? i.one : i.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildFormatLongFn.js
function ee(e) {
	return (t = {}) => {
		let n = t.width ? String(t.width) : e.defaultWidth;
		return e.formats[n] || e.formats[e.defaultWidth];
	};
}
var te = {
	date: ee({
		formats: {
			full: "EEEE, MMMM do, y",
			long: "MMMM do, y",
			medium: "MMM d, y",
			short: "MM/dd/yyyy"
		},
		defaultWidth: "full"
	}),
	time: ee({
		formats: {
			full: "h:mm:ss a zzzz",
			long: "h:mm:ss a z",
			medium: "h:mm:ss a",
			short: "h:mm a"
		},
		defaultWidth: "full"
	}),
	dateTime: ee({
		formats: {
			full: "{{date}} 'at' {{time}}",
			long: "{{date}} 'at' {{time}}",
			medium: "{{date}}, {{time}}",
			short: "{{date}}, {{time}}"
		},
		defaultWidth: "full"
	})
}, ne = {
	lastWeek: "'last' eeee 'at' p",
	yesterday: "'yesterday at' p",
	today: "'today at' p",
	tomorrow: "'tomorrow at' p",
	nextWeek: "eeee 'at' p",
	other: "P"
}, re = (e, t, n, r) => ne[e];
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildLocalizeFn.js
function m(e) {
	return (t, n) => {
		let r = n?.context ? String(n.context) : "standalone", i;
		if (r === "formatting" && e.formattingValues) {
			let t = e.defaultFormattingWidth || e.defaultWidth, r = n?.width ? String(n.width) : t;
			i = e.formattingValues[r] || e.formattingValues[t];
		} else {
			let t = e.defaultWidth, r = n?.width ? String(n.width) : e.defaultWidth;
			i = e.values[r] || e.values[t];
		}
		let a = e.argumentCallback ? e.argumentCallback(t) : t;
		return i[a];
	};
}
var ie = {
	ordinalNumber: (e, t) => {
		let n = Number(e), r = n % 100;
		if (r > 20 || r < 10) switch (r % 10) {
			case 1: return n + "st";
			case 2: return n + "nd";
			case 3: return n + "rd";
		}
		return n + "th";
	},
	era: m({
		values: {
			narrow: ["B", "A"],
			abbreviated: ["BC", "AD"],
			wide: ["Before Christ", "Anno Domini"]
		},
		defaultWidth: "wide"
	}),
	quarter: m({
		values: {
			narrow: [
				"1",
				"2",
				"3",
				"4"
			],
			abbreviated: [
				"Q1",
				"Q2",
				"Q3",
				"Q4"
			],
			wide: [
				"1st quarter",
				"2nd quarter",
				"3rd quarter",
				"4th quarter"
			]
		},
		defaultWidth: "wide",
		argumentCallback: (e) => e - 1
	}),
	month: m({
		values: {
			narrow: [
				"J",
				"F",
				"M",
				"A",
				"M",
				"J",
				"J",
				"A",
				"S",
				"O",
				"N",
				"D"
			],
			abbreviated: [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec"
			],
			wide: [
				"January",
				"February",
				"March",
				"April",
				"May",
				"June",
				"July",
				"August",
				"September",
				"October",
				"November",
				"December"
			]
		},
		defaultWidth: "wide"
	}),
	day: m({
		values: {
			narrow: [
				"S",
				"M",
				"T",
				"W",
				"T",
				"F",
				"S"
			],
			short: [
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			],
			abbreviated: [
				"Sun",
				"Mon",
				"Tue",
				"Wed",
				"Thu",
				"Fri",
				"Sat"
			],
			wide: [
				"Sunday",
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday"
			]
		},
		defaultWidth: "wide"
	}),
	dayPeriod: m({
		values: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "morning",
				afternoon: "afternoon",
				evening: "evening",
				night: "night"
			}
		},
		defaultWidth: "wide",
		formattingValues: {
			narrow: {
				am: "a",
				pm: "p",
				midnight: "mi",
				noon: "n",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			abbreviated: {
				am: "AM",
				pm: "PM",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			},
			wide: {
				am: "a.m.",
				pm: "p.m.",
				midnight: "midnight",
				noon: "noon",
				morning: "in the morning",
				afternoon: "in the afternoon",
				evening: "in the evening",
				night: "at night"
			}
		},
		defaultFormattingWidth: "wide"
	})
};
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildMatchFn.js
function h(e) {
	return (t, n = {}) => {
		let r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
		if (!a) return null;
		let o = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? oe(s, (e) => e.test(o)) : ae(s, (e) => e.test(o)), l;
		l = e.valueCallback ? e.valueCallback(c) : c, l = n.valueCallback ? n.valueCallback(l) : l;
		let u = t.slice(o.length);
		return {
			value: l,
			rest: u
		};
	};
}
function ae(e, t) {
	for (let n in e) if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n])) return n;
}
function oe(e, t) {
	for (let n = 0; n < e.length; n++) if (t(e[n])) return n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/_lib/buildMatchPatternFn.js
function se(e) {
	return (t, n = {}) => {
		let r = t.match(e.matchPattern);
		if (!r) return null;
		let i = r[0], a = t.match(e.parsePattern);
		if (!a) return null;
		let o = e.valueCallback ? e.valueCallback(a[0]) : a[0];
		o = n.valueCallback ? n.valueCallback(o) : o;
		let s = t.slice(i.length);
		return {
			value: o,
			rest: s
		};
	};
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/locale/en-US.js
var ce = {
	code: "en-US",
	formatDistance: p,
	formatLong: te,
	formatRelative: re,
	localize: ie,
	match: {
		ordinalNumber: se({
			matchPattern: /^(\d+)(th|st|nd|rd)?/i,
			parsePattern: /\d+/i,
			valueCallback: (e) => parseInt(e, 10)
		}),
		era: h({
			matchPatterns: {
				narrow: /^(b|a)/i,
				abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
				wide: /^(before christ|before common era|anno domini|common era)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [/^b/i, /^(a|c)/i] },
			defaultParseWidth: "any"
		}),
		quarter: h({
			matchPatterns: {
				narrow: /^[1234]/i,
				abbreviated: /^q[1234]/i,
				wide: /^[1234](th|st|nd|rd)? quarter/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: { any: [
				/1/i,
				/2/i,
				/3/i,
				/4/i
			] },
			defaultParseWidth: "any",
			valueCallback: (e) => e + 1
		}),
		month: h({
			matchPatterns: {
				narrow: /^[jfmasond]/i,
				abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
				wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^j/i,
					/^f/i,
					/^m/i,
					/^a/i,
					/^m/i,
					/^j/i,
					/^j/i,
					/^a/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				],
				any: [
					/^ja/i,
					/^f/i,
					/^mar/i,
					/^ap/i,
					/^may/i,
					/^jun/i,
					/^jul/i,
					/^au/i,
					/^s/i,
					/^o/i,
					/^n/i,
					/^d/i
				]
			},
			defaultParseWidth: "any"
		}),
		day: h({
			matchPatterns: {
				narrow: /^[smtwf]/i,
				short: /^(su|mo|tu|we|th|fr|sa)/i,
				abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
				wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
			},
			defaultMatchWidth: "wide",
			parsePatterns: {
				narrow: [
					/^s/i,
					/^m/i,
					/^t/i,
					/^w/i,
					/^t/i,
					/^f/i,
					/^s/i
				],
				any: [
					/^su/i,
					/^m/i,
					/^tu/i,
					/^w/i,
					/^th/i,
					/^f/i,
					/^sa/i
				]
			},
			defaultParseWidth: "any"
		}),
		dayPeriod: h({
			matchPatterns: {
				narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
				any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
			},
			defaultMatchWidth: "any",
			parsePatterns: { any: {
				am: /^a/i,
				pm: /^p/i,
				midnight: /^mi/i,
				noon: /^no/i,
				morning: /morning/i,
				afternoon: /afternoon/i,
				evening: /evening/i,
				night: /night/i
			} },
			defaultParseWidth: "any"
		})
	},
	options: {
		weekStartsOn: 0,
		firstWeekContainsDate: 1
	}
}, le = {};
function ue() {
	return le;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/constants.js
var de = 365.2425, fe = 6048e5, pe = 864e5, me = 3600 * 24;
me * 7, me * de / 12 * 3;
var he = Symbol.for("constructDateFrom");
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/constructFrom.js
function g(e, t) {
	return typeof e == "function" ? e(t) : e && typeof e == "object" && he in e ? e[he](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/toDate.js
function _(e, t) {
	return g(t || e, e);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/getTimezoneOffsetInMilliseconds.js
function ge(e) {
	let t = _(e), n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
	return n.setUTCFullYear(t.getFullYear()), e - +n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/normalizeDates.js
function _e(e, ...t) {
	let n = g.bind(null, e || t.find((e) => typeof e == "object"));
	return t.map(n);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfDay.js
function ve(e, t) {
	let n = _(e, t?.in);
	return n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/differenceInCalendarDays.js
function ye(e, t, n) {
	let [r, i] = _e(n?.in, e, t), a = ve(r), o = ve(i), s = +a - ge(a), c = +o - ge(o);
	return Math.round((s - c) / pe);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfYear.js
function be(e, t) {
	let n = _(e, t?.in);
	return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getDayOfYear.js
function xe(e, t) {
	let n = _(e, t?.in);
	return ye(n, be(n)) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfWeek.js
function v(e, t) {
	let n = ue(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, i = _(e, t?.in), a = i.getDay(), o = (a < r ? 7 : 0) + a - r;
	return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfISOWeek.js
function Se(e, t) {
	return v(e, {
		...t,
		weekStartsOn: 1
	});
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getISOWeekYear.js
function Ce(e, t) {
	let n = _(e, t?.in), r = n.getFullYear(), i = g(n, 0);
	i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
	let a = Se(i), o = g(n, 0);
	o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
	let s = Se(o);
	return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= s.getTime() ? r : r - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfISOWeekYear.js
function we(e, t) {
	let n = Ce(e, t), r = g(t?.in || e, 0);
	return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Se(r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getISOWeek.js
function Te(e, t) {
	let n = _(e, t?.in), r = Se(n) - +we(n);
	return Math.round(r / fe) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getWeekYear.js
function Ee(e, t) {
	let n = _(e, t?.in), r = n.getFullYear(), i = ue(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = g(t?.in || e, 0);
	o.setFullYear(r + 1, 0, a), o.setHours(0, 0, 0, 0);
	let s = v(o, t), c = g(t?.in || e, 0);
	c.setFullYear(r, 0, a), c.setHours(0, 0, 0, 0);
	let l = v(c, t);
	return +n >= +s ? r + 1 : +n >= +l ? r : r - 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/startOfWeekYear.js
function De(e, t) {
	let n = ue(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, i = Ee(e, t), a = g(t?.in || e, 0);
	return a.setFullYear(i, 0, r), a.setHours(0, 0, 0, 0), v(a, t);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/getWeek.js
function Oe(e, t) {
	let n = _(e, t?.in), r = v(n, t) - +De(n, t);
	return Math.round(r / fe) + 1;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/addLeadingZeros.js
function y(e, t) {
	return (e < 0 ? "-" : "") + Math.abs(e).toString().padStart(t, "0");
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/format/lightFormatters.js
var b = {
	y(e, t) {
		let n = e.getFullYear(), r = n > 0 ? n : 1 - n;
		return y(t === "yy" ? r % 100 : r, t.length);
	},
	M(e, t) {
		let n = e.getMonth();
		return t === "M" ? String(n + 1) : y(n + 1, 2);
	},
	d(e, t) {
		return y(e.getDate(), t.length);
	},
	a(e, t) {
		let n = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.toUpperCase();
			case "aaa": return n;
			case "aaaaa": return n[0];
			default: return n === "am" ? "a.m." : "p.m.";
		}
	},
	h(e, t) {
		return y(e.getHours() % 12 || 12, t.length);
	},
	H(e, t) {
		return y(e.getHours(), t.length);
	},
	m(e, t) {
		return y(e.getMinutes(), t.length);
	},
	s(e, t) {
		return y(e.getSeconds(), t.length);
	},
	S(e, t) {
		let n = t.length, r = e.getMilliseconds();
		return y(Math.trunc(r * 10 ** (n - 3)), t.length);
	}
}, x = {
	am: "am",
	pm: "pm",
	midnight: "midnight",
	noon: "noon",
	morning: "morning",
	afternoon: "afternoon",
	evening: "evening",
	night: "night"
}, ke = {
	G: function(e, t, n) {
		let r = e.getFullYear() > 0 ? 1 : 0;
		switch (t) {
			case "G":
			case "GG":
			case "GGG": return n.era(r, { width: "abbreviated" });
			case "GGGGG": return n.era(r, { width: "narrow" });
			default: return n.era(r, { width: "wide" });
		}
	},
	y: function(e, t, n) {
		if (t === "yo") {
			let t = e.getFullYear(), r = t > 0 ? t : 1 - t;
			return n.ordinalNumber(r, { unit: "year" });
		}
		return b.y(e, t);
	},
	Y: function(e, t, n, r) {
		let i = Ee(e, r), a = i > 0 ? i : 1 - i;
		return t === "YY" ? y(a % 100, 2) : t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : y(a, t.length);
	},
	R: function(e, t) {
		return y(Ce(e), t.length);
	},
	u: function(e, t) {
		return y(e.getFullYear(), t.length);
	},
	Q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "Q": return String(r);
			case "QQ": return y(r, 2);
			case "Qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "QQQ": return n.quarter(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "QQQQQ": return n.quarter(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	q: function(e, t, n) {
		let r = Math.ceil((e.getMonth() + 1) / 3);
		switch (t) {
			case "q": return String(r);
			case "qq": return y(r, 2);
			case "qo": return n.ordinalNumber(r, { unit: "quarter" });
			case "qqq": return n.quarter(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "qqqqq": return n.quarter(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.quarter(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	M: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "M":
			case "MM": return b.M(e, t);
			case "Mo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "MMM": return n.month(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "MMMMM": return n.month(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.month(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	L: function(e, t, n) {
		let r = e.getMonth();
		switch (t) {
			case "L": return String(r + 1);
			case "LL": return y(r + 1, 2);
			case "Lo": return n.ordinalNumber(r + 1, { unit: "month" });
			case "LLL": return n.month(r, {
				width: "abbreviated",
				context: "standalone"
			});
			case "LLLLL": return n.month(r, {
				width: "narrow",
				context: "standalone"
			});
			default: return n.month(r, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	w: function(e, t, n, r) {
		let i = Oe(e, r);
		return t === "wo" ? n.ordinalNumber(i, { unit: "week" }) : y(i, t.length);
	},
	I: function(e, t, n) {
		let r = Te(e);
		return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : y(r, t.length);
	},
	d: function(e, t, n) {
		return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : b.d(e, t);
	},
	D: function(e, t, n) {
		let r = xe(e);
		return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : y(r, t.length);
	},
	E: function(e, t, n) {
		let r = e.getDay();
		switch (t) {
			case "E":
			case "EE":
			case "EEE": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "EEEEE": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "EEEEEE": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	e: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "e": return String(a);
			case "ee": return y(a, 2);
			case "eo": return n.ordinalNumber(a, { unit: "day" });
			case "eee": return n.day(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "eeeee": return n.day(i, {
				width: "narrow",
				context: "formatting"
			});
			case "eeeeee": return n.day(i, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	c: function(e, t, n, r) {
		let i = e.getDay(), a = (i - r.weekStartsOn + 8) % 7 || 7;
		switch (t) {
			case "c": return String(a);
			case "cc": return y(a, t.length);
			case "co": return n.ordinalNumber(a, { unit: "day" });
			case "ccc": return n.day(i, {
				width: "abbreviated",
				context: "standalone"
			});
			case "ccccc": return n.day(i, {
				width: "narrow",
				context: "standalone"
			});
			case "cccccc": return n.day(i, {
				width: "short",
				context: "standalone"
			});
			default: return n.day(i, {
				width: "wide",
				context: "standalone"
			});
		}
	},
	i: function(e, t, n) {
		let r = e.getDay(), i = r === 0 ? 7 : r;
		switch (t) {
			case "i": return String(i);
			case "ii": return y(i, t.length);
			case "io": return n.ordinalNumber(i, { unit: "day" });
			case "iii": return n.day(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "iiiii": return n.day(r, {
				width: "narrow",
				context: "formatting"
			});
			case "iiiiii": return n.day(r, {
				width: "short",
				context: "formatting"
			});
			default: return n.day(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	a: function(e, t, n) {
		let r = e.getHours() / 12 >= 1 ? "pm" : "am";
		switch (t) {
			case "a":
			case "aa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			});
			case "aaa": return n.dayPeriod(r, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "aaaaa": return n.dayPeriod(r, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(r, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	b: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r === 12 ? x.noon : r === 0 ? x.midnight : r / 12 >= 1 ? "pm" : "am", t) {
			case "b":
			case "bb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "bbb": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			}).toLowerCase();
			case "bbbbb": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	B: function(e, t, n) {
		let r = e.getHours(), i;
		switch (i = r >= 17 ? x.evening : r >= 12 ? x.afternoon : r >= 4 ? x.morning : x.night, t) {
			case "B":
			case "BB":
			case "BBB": return n.dayPeriod(i, {
				width: "abbreviated",
				context: "formatting"
			});
			case "BBBBB": return n.dayPeriod(i, {
				width: "narrow",
				context: "formatting"
			});
			default: return n.dayPeriod(i, {
				width: "wide",
				context: "formatting"
			});
		}
	},
	h: function(e, t, n) {
		if (t === "ho") {
			let t = e.getHours() % 12;
			return t === 0 && (t = 12), n.ordinalNumber(t, { unit: "hour" });
		}
		return b.h(e, t);
	},
	H: function(e, t, n) {
		return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : b.H(e, t);
	},
	K: function(e, t, n) {
		let r = e.getHours() % 12;
		return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : y(r, t.length);
	},
	k: function(e, t, n) {
		let r = e.getHours();
		return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : y(r, t.length);
	},
	m: function(e, t, n) {
		return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : b.m(e, t);
	},
	s: function(e, t, n) {
		return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : b.s(e, t);
	},
	S: function(e, t) {
		return b.S(e, t);
	},
	X: function(e, t, n) {
		let r = e.getTimezoneOffset();
		if (r === 0) return "Z";
		switch (t) {
			case "X": return je(r);
			case "XXXX":
			case "XX": return S(r);
			default: return S(r, ":");
		}
	},
	x: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "x": return je(r);
			case "xxxx":
			case "xx": return S(r);
			default: return S(r, ":");
		}
	},
	O: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "O":
			case "OO":
			case "OOO": return "GMT" + Ae(r, ":");
			default: return "GMT" + S(r, ":");
		}
	},
	z: function(e, t, n) {
		let r = e.getTimezoneOffset();
		switch (t) {
			case "z":
			case "zz":
			case "zzz": return "GMT" + Ae(r, ":");
			default: return "GMT" + S(r, ":");
		}
	},
	t: function(e, t, n) {
		return y(Math.trunc(e / 1e3), t.length);
	},
	T: function(e, t, n) {
		return y(+e, t.length);
	}
};
function Ae(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.trunc(r / 60), a = r % 60;
	return a === 0 ? n + String(i) : n + String(i) + t + y(a, 2);
}
function je(e, t) {
	return e % 60 == 0 ? (e > 0 ? "-" : "+") + y(Math.abs(e) / 60, 2) : S(e, t);
}
function S(e, t = "") {
	let n = e > 0 ? "-" : "+", r = Math.abs(e), i = y(Math.trunc(r / 60), 2), a = y(r % 60, 2);
	return n + i + t + a;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/_lib/format/longFormatters.js
var Me = (e, t) => {
	switch (e) {
		case "P": return t.date({ width: "short" });
		case "PP": return t.date({ width: "medium" });
		case "PPP": return t.date({ width: "long" });
		default: return t.date({ width: "full" });
	}
}, Ne = (e, t) => {
	switch (e) {
		case "p": return t.time({ width: "short" });
		case "pp": return t.time({ width: "medium" });
		case "ppp": return t.time({ width: "long" });
		default: return t.time({ width: "full" });
	}
}, Pe = {
	p: Ne,
	P: (e, t) => {
		let n = e.match(/(P+)(p+)?/) || [], r = n[1], i = n[2];
		if (!i) return Me(e, t);
		let a;
		switch (r) {
			case "P":
				a = t.dateTime({ width: "short" });
				break;
			case "PP":
				a = t.dateTime({ width: "medium" });
				break;
			case "PPP":
				a = t.dateTime({ width: "long" });
				break;
			default:
				a = t.dateTime({ width: "full" });
				break;
		}
		return a.replace("{{date}}", Me(r, t)).replace("{{time}}", Ne(i, t));
	}
}, Fe = /^D+$/, Ie = /^Y+$/, Le = [
	"D",
	"DD",
	"YY",
	"YYYY"
];
function Re(e) {
	return Fe.test(e);
}
function ze(e) {
	return Ie.test(e);
}
function Be(e, t, n) {
	let r = Ve(e, t, n);
	if (console.warn(r), Le.includes(e)) throw RangeError(r);
}
function Ve(e, t, n) {
	let r = e[0] === "Y" ? "years" : "days of the month";
	return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/isDate.js
function He(e) {
	return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/isValid.js
function Ue(e) {
	return !(!He(e) && typeof e != "number" || isNaN(+_(e)));
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/format.js
var We = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ge = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ke = /^'([^]*?)'?$/, qe = /''/g, Je = /[a-zA-Z]/;
function Ye(e, t, n) {
	let r = ue(), i = n?.locale ?? r.locale ?? ce, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = _(e, n?.in);
	if (!Ue(s)) throw RangeError("Invalid time value");
	let c = t.match(Ge).map((e) => {
		let t = e[0];
		if (t === "p" || t === "P") {
			let n = Pe[t];
			return n(e, i.formatLong);
		}
		return e;
	}).join("").match(We).map((e) => {
		if (e === "''") return {
			isToken: !1,
			value: "'"
		};
		let t = e[0];
		if (t === "'") return {
			isToken: !1,
			value: Xe(e)
		};
		if (ke[t]) return {
			isToken: !0,
			value: e
		};
		if (t.match(Je)) throw RangeError("Format string contains an unescaped latin alphabet character `" + t + "`");
		return {
			isToken: !1,
			value: e
		};
	});
	i.localize.preprocessor && (c = i.localize.preprocessor(s, c));
	let l = {
		firstWeekContainsDate: a,
		weekStartsOn: o,
		locale: i
	};
	return c.map((r) => {
		if (!r.isToken) return r.value;
		let a = r.value;
		(!n?.useAdditionalWeekYearTokens && ze(a) || !n?.useAdditionalDayOfYearTokens && Re(a)) && Be(a, t, String(e));
		let o = ke[a[0]];
		return o(s, a, i.localize, l);
	}).join("");
}
function Xe(e) {
	let t = e.match(Ke);
	return t ? t[1].replace(qe, "'") : e;
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/addDays.js
function Ze(e, t, n) {
	let r = _(e, n?.in);
	return isNaN(t) ? g(n?.in || e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
//#endregion
//#region ../../node_modules/.pnpm/date-fns@4.1.0/node_modules/date-fns/subDays.js
function Qe(e, t, n) {
	return Ze(e, -t, n);
}
//#endregion
//#region src/dates.ts
function $e(e) {
	return e ? Ye(new Date(e), "PP") : null;
}
//#endregion
//#region src/geo-math.ts
var et = 6371e3;
function tt(e) {
	return e * Math.PI / 180;
}
function nt(e, t) {
	let n = tt(t.lat - e.lat), r = tt(t.lng - e.lng), i = tt(e.lat), a = tt(t.lat), o = Math.sin(n / 2), s = Math.sin(r / 2), c = o * o + Math.cos(i) * Math.cos(a) * s * s;
	return 2 * et * Math.asin(Math.min(1, Math.sqrt(c)));
}
function rt(e, t, n) {
	let r = tt(t.lat), i = Math.cos(r), a = (e) => ({
		x: (e.lng - t.lng) * i,
		y: e.lat - t.lat
	}), o = a(t), s = a(n), c = a(e), l = s.x - o.x, u = s.y - o.y, d = l * l + u * u, f = d === 0 ? 0 : Math.min(1, Math.max(0, ((c.x - o.x) * l + (c.y - o.y) * u) / d)), p = {
		lat: t.lat + f * (n.lat - t.lat),
		lng: t.lng + f * (n.lng - t.lng)
	};
	return {
		point: p,
		distanceMeters: nt(e, p),
		fraction: f
	};
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.4.3/node_modules/zod/v4/core/core.js
var it, at = /* @__PURE__ */ Object.freeze({ status: "aborted" });
function C(e, t, n) {
	function r(n, r) {
		if (n._zod || Object.defineProperty(n, "_zod", {
			value: {
				def: r,
				constr: o,
				traits: /* @__PURE__ */ new Set()
			},
			enumerable: !1
		}), n._zod.traits.has(e)) return;
		n._zod.traits.add(e), t(n, r);
		let i = o.prototype, a = Object.keys(i);
		for (let e = 0; e < a.length; e++) {
			let t = a[e];
			t in n || (n[t] = i[t].bind(n));
		}
	}
	let i = n?.Parent ?? Object;
	class a extends i {}
	Object.defineProperty(a, "name", { value: e });
	function o(e) {
		var t;
		let i = n?.Parent ? new a() : this;
		r(i, e), (t = i._zod).deferred ?? (t.deferred = []);
		for (let e of i._zod.deferred) e();
		return i;
	}
	return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, { value: (t) => n?.Parent && t instanceof n.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(o, "name", { value: e }), o;
}
var w = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
}, ot = class extends Error {
	constructor(e) {
		super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
	}
};
(it = globalThis).__zod_globalConfig ?? (it.__zod_globalConfig = {});
var st = globalThis.__zod_globalConfig;
function T(e) {
	return e && Object.assign(st, e), st;
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.4.3/node_modules/zod/v4/core/util.js
function ct(e) {
	let t = Object.values(e).filter((e) => typeof e == "number");
	return Object.entries(e).filter(([e, n]) => t.indexOf(+e) === -1).map(([e, t]) => t);
}
function lt(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
function ut(e) {
	return { get value() {
		{
			let t = e();
			return Object.defineProperty(this, "value", { value: t }), t;
		}
		throw Error("cached value already set");
	} };
}
function dt(e) {
	return e == null;
}
function ft(e) {
	let t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
	return e.slice(t, n);
}
function pt(e, t) {
	let n = e / t, r = Math.round(n), i = 2 ** -52 * Math.max(Math.abs(n), 1);
	return Math.abs(n - r) < i ? 0 : n - r;
}
var mt = /* @__PURE__ */ Symbol("evaluating");
function E(e, t, n) {
	let r;
	Object.defineProperty(e, t, {
		get() {
			if (r !== mt) return r === void 0 && (r = mt, r = n()), r;
		},
		set(n) {
			Object.defineProperty(e, t, { value: n });
		},
		configurable: !0
	});
}
function D(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}
function O(...e) {
	let t = {};
	for (let n of e) {
		let e = Object.getOwnPropertyDescriptors(n);
		Object.assign(t, e);
	}
	return Object.defineProperties({}, t);
}
function ht(e) {
	return JSON.stringify(e);
}
function gt(e) {
	return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
var _t = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
function vt(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
var yt = /* @__PURE__ */ ut(() => {
	if (st.jitless || typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare")) return !1;
	try {
		return Function(""), !0;
	} catch {
		return !1;
	}
});
function k(e) {
	if (vt(e) === !1) return !1;
	let t = e.constructor;
	if (t === void 0 || typeof t != "function") return !0;
	let n = t.prototype;
	return !(vt(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function bt(e) {
	return k(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
var xt = /* @__PURE__ */ new Set([
	"string",
	"number",
	"symbol"
]);
function A(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function j(e, t, n) {
	let r = new e._zod.constr(t ?? e._zod.def);
	return (!t || n?.parent) && (r._zod.parent = e), r;
}
function M(e) {
	let t = e;
	if (!t) return {};
	if (typeof t == "string") return { error: () => t };
	if (t?.message !== void 0) {
		if (t?.error !== void 0) throw Error("Cannot specify both `message` and `error` params");
		t.error = t.message;
	}
	return delete t.message, typeof t.error == "string" ? {
		...t,
		error: () => t.error
	} : t;
}
function St(e) {
	return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
var Ct = {
	safeint: [-(2 ** 53 - 1), 2 ** 53 - 1],
	int32: [-2147483648, 2147483647],
	uint32: [0, 4294967295],
	float32: [-34028234663852886e22, 34028234663852886e22],
	float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function wt(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".pick() cannot be used on object schemas containing refinements");
	return j(e, O(e._zod.def, {
		get shape() {
			let e = {};
			for (let r in t) {
				if (!(r in n.shape)) throw Error(`Unrecognized key: "${r}"`);
				t[r] && (e[r] = n.shape[r]);
			}
			return D(this, "shape", e), e;
		},
		checks: []
	}));
}
function Tt(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".omit() cannot be used on object schemas containing refinements");
	return j(e, O(e._zod.def, {
		get shape() {
			let r = { ...e._zod.def.shape };
			for (let e in t) {
				if (!(e in n.shape)) throw Error(`Unrecognized key: "${e}"`);
				t[e] && delete r[e];
			}
			return D(this, "shape", r), r;
		},
		checks: []
	}));
}
function Et(e, t) {
	if (!k(t)) throw Error("Invalid input to extend: expected a plain object");
	let n = e._zod.def.checks;
	if (n && n.length > 0) {
		let n = e._zod.def.shape;
		for (let e in t) if (Object.getOwnPropertyDescriptor(n, e) !== void 0) throw Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
	}
	return j(e, O(e._zod.def, { get shape() {
		let n = {
			...e._zod.def.shape,
			...t
		};
		return D(this, "shape", n), n;
	} }));
}
function Dt(e, t) {
	if (!k(t)) throw Error("Invalid input to safeExtend: expected a plain object");
	return j(e, O(e._zod.def, { get shape() {
		let n = {
			...e._zod.def.shape,
			...t
		};
		return D(this, "shape", n), n;
	} }));
}
function Ot(e, t) {
	if (e._zod.def.checks?.length) throw Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
	return j(e, O(e._zod.def, {
		get shape() {
			let n = {
				...e._zod.def.shape,
				...t._zod.def.shape
			};
			return D(this, "shape", n), n;
		},
		get catchall() {
			return t._zod.def.catchall;
		},
		checks: t._zod.def.checks ?? []
	}));
}
function kt(e, t, n) {
	let r = t._zod.def.checks;
	if (r && r.length > 0) throw Error(".partial() cannot be used on object schemas containing refinements");
	return j(t, O(t._zod.def, {
		get shape() {
			let r = t._zod.def.shape, i = { ...r };
			if (n) for (let t in n) {
				if (!(t in r)) throw Error(`Unrecognized key: "${t}"`);
				n[t] && (i[t] = e ? new e({
					type: "optional",
					innerType: r[t]
				}) : r[t]);
			}
			else for (let t in r) i[t] = e ? new e({
				type: "optional",
				innerType: r[t]
			}) : r[t];
			return D(this, "shape", i), i;
		},
		checks: []
	}));
}
function At(e, t, n) {
	return j(t, O(t._zod.def, { get shape() {
		let r = t._zod.def.shape, i = { ...r };
		if (n) for (let t in n) {
			if (!(t in i)) throw Error(`Unrecognized key: "${t}"`);
			n[t] && (i[t] = new e({
				type: "nonoptional",
				innerType: r[t]
			}));
		}
		else for (let t in r) i[t] = new e({
			type: "nonoptional",
			innerType: r[t]
		});
		return D(this, "shape", i), i;
	} }));
}
function N(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue !== !0) return !0;
	return !1;
}
function jt(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue === !1) return !0;
	return !1;
}
function Mt(e, t) {
	return t.map((t) => {
		var n;
		return (n = t).path ?? (n.path = []), t.path.unshift(e), t;
	});
}
function Nt(e) {
	return typeof e == "string" ? e : e?.message;
}
function P(e, t, n) {
	let r = e.message ? e.message : Nt(e.inst?._zod.def?.error?.(e)) ?? Nt(t?.error?.(e)) ?? Nt(n.customError?.(e)) ?? Nt(n.localeError?.(e)) ?? "Invalid input", { inst: i, continue: a, input: o, ...s } = e;
	return s.path ??= [], s.message = r, t?.reportInput && (s.input = o), s;
}
function Pt(e) {
	return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function F(...e) {
	let [t, n, r] = e;
	return typeof t == "string" ? {
		message: t,
		code: "custom",
		input: n,
		inst: r
	} : { ...t };
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.4.3/node_modules/zod/v4/core/errors.js
var Ft = (e, t) => {
	e.name = "$ZodError", Object.defineProperty(e, "_zod", {
		value: e._zod,
		enumerable: !1
	}), Object.defineProperty(e, "issues", {
		value: t,
		enumerable: !1
	}), e.message = JSON.stringify(t, lt, 2), Object.defineProperty(e, "toString", {
		value: () => e.message,
		enumerable: !1
	});
}, It = C("$ZodError", Ft), Lt = C("$ZodError", Ft, { Parent: Error });
function Rt(e, t = (e) => e.message) {
	let n = {}, r = [];
	for (let i of e.issues) i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
	return {
		formErrors: r,
		fieldErrors: n
	};
}
function zt(e, t = (e) => e.message) {
	let n = { _errors: [] }, r = (e, i = []) => {
		for (let a of e.issues) if (a.code === "invalid_union" && a.errors.length) a.errors.map((e) => r({ issues: e }, [...i, ...a.path]));
		else if (a.code === "invalid_key") r({ issues: a.issues }, [...i, ...a.path]);
		else if (a.code === "invalid_element") r({ issues: a.issues }, [...i, ...a.path]);
		else {
			let e = [...i, ...a.path];
			if (e.length === 0) n._errors.push(t(a));
			else {
				let r = n, i = 0;
				for (; i < e.length;) {
					let n = e[i];
					i === e.length - 1 ? (r[n] = r[n] || { _errors: [] }, r[n]._errors.push(t(a))) : r[n] = r[n] || { _errors: [] }, r = r[n], i++;
				}
			}
		}
	};
	return r(e), n;
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.4.3/node_modules/zod/v4/core/parse.js
var Bt = (e) => (t, n, r, i) => {
	let a = r ? {
		...r,
		async: !1
	} : { async: !1 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise) throw new w();
	if (o.issues.length) {
		let t = new (i?.Err ?? e)(o.issues.map((e) => P(e, a, T())));
		throw _t(t, i?.callee), t;
	}
	return o.value;
}, Vt = (e) => async (t, n, r, i) => {
	let a = r ? {
		...r,
		async: !0
	} : { async: !0 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise && (o = await o), o.issues.length) {
		let t = new (i?.Err ?? e)(o.issues.map((e) => P(e, a, T())));
		throw _t(t, i?.callee), t;
	}
	return o.value;
}, Ht = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		async: !1
	} : { async: !1 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	if (a instanceof Promise) throw new w();
	return a.issues.length ? {
		success: !1,
		error: new (e ?? It)(a.issues.map((e) => P(e, i, T())))
	} : {
		success: !0,
		data: a.value
	};
}, Ut = /* @__PURE__ */ Ht(Lt), Wt = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		async: !0
	} : { async: !0 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	return a instanceof Promise && (a = await a), a.issues.length ? {
		success: !1,
		error: new e(a.issues.map((e) => P(e, i, T())))
	} : {
		success: !0,
		data: a.value
	};
}, Gt = /* @__PURE__ */ Wt(Lt), Kt = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return Bt(e)(t, n, i);
}, qt = (e) => (t, n, r) => Bt(e)(t, n, r), Jt = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return Vt(e)(t, n, i);
}, Yt = (e) => async (t, n, r) => Vt(e)(t, n, r), Xt = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return Ht(e)(t, n, i);
}, Zt = (e) => (t, n, r) => Ht(e)(t, n, r), Qt = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return Wt(e)(t, n, i);
}, $t = (e) => async (t, n, r) => Wt(e)(t, n, r), en = /^[cC][0-9a-z]{6,}$/, tn = /^[0-9a-z]+$/, nn = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, rn = /^[0-9a-vA-V]{20}$/, an = /^[A-Za-z0-9]{27}$/, on = /^[a-zA-Z0-9_-]{21}$/, sn = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, cn = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, ln = (e) => e ? RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, un = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, dn = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function fn() {
	return new RegExp(dn, "u");
}
var pn = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, mn = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, hn = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, gn = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, _n = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, vn = /^[A-Za-z0-9_-]*$/, yn = /^https?$/, bn = /^\+[1-9]\d{6,14}$/, xn = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Sn = /* @__PURE__ */ RegExp(`^${xn}$`);
function Cn(e) {
	let t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
	return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function wn(e) {
	return RegExp(`^${Cn(e)}$`);
}
function Tn(e) {
	let t = Cn({ precision: e.precision }), n = ["Z"];
	e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
	let r = `${t}(?:${n.join("|")})`;
	return RegExp(`^${xn}T(?:${r})$`);
}
var En = (e) => {
	let t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
	return RegExp(`^${t}$`);
}, Dn = /^-?\d+$/, On = /^-?\d+(?:\.\d+)?$/, kn = /^[^A-Z]*$/, An = /^[^a-z]*$/, I = /* @__PURE__ */ C("$ZodCheck", (e, t) => {
	var n;
	e._zod ??= {}, e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), jn = {
	number: "number",
	bigint: "bigint",
	object: "date"
}, Mn = /* @__PURE__ */ C("$ZodCheckLessThan", (e, t) => {
	I.init(e, t);
	let n = jn[typeof t.value];
	e._zod.onattach.push((e) => {
		let n = e._zod.bag, r = (t.inclusive ? n.maximum : n.exclusiveMaximum) ?? Infinity;
		t.value < r && (t.inclusive ? n.maximum = t.value : n.exclusiveMaximum = t.value);
	}), e._zod.check = (r) => {
		(t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
			origin: n,
			code: "too_big",
			maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), Nn = /* @__PURE__ */ C("$ZodCheckGreaterThan", (e, t) => {
	I.init(e, t);
	let n = jn[typeof t.value];
	e._zod.onattach.push((e) => {
		let n = e._zod.bag, r = (t.inclusive ? n.minimum : n.exclusiveMinimum) ?? -Infinity;
		t.value > r && (t.inclusive ? n.minimum = t.value : n.exclusiveMinimum = t.value);
	}), e._zod.check = (r) => {
		(t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
			origin: n,
			code: "too_small",
			minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), Pn = /* @__PURE__ */ C("$ZodCheckMultipleOf", (e, t) => {
	I.init(e, t), e._zod.onattach.push((e) => {
		var n;
		(n = e._zod.bag).multipleOf ?? (n.multipleOf = t.value);
	}), e._zod.check = (n) => {
		if (typeof n.value != typeof t.value) throw Error("Cannot mix number and bigint in multiple_of check.");
		(typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : pt(n.value, t.value) === 0) || n.issues.push({
			origin: typeof n.value,
			code: "not_multiple_of",
			divisor: t.value,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Fn = /* @__PURE__ */ C("$ZodCheckNumberFormat", (e, t) => {
	I.init(e, t), t.format = t.format || "float64";
	let n = t.format?.includes("int"), r = n ? "int" : "number", [i, a] = Ct[t.format];
	e._zod.onattach.push((e) => {
		let r = e._zod.bag;
		r.format = t.format, r.minimum = i, r.maximum = a, n && (r.pattern = Dn);
	}), e._zod.check = (o) => {
		let s = o.value;
		if (n) {
			if (!Number.isInteger(s)) {
				o.issues.push({
					expected: r,
					format: t.format,
					code: "invalid_type",
					continue: !1,
					input: s,
					inst: e
				});
				return;
			}
			if (!Number.isSafeInteger(s)) {
				s > 0 ? o.issues.push({
					input: s,
					code: "too_big",
					maximum: 2 ** 53 - 1,
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				}) : o.issues.push({
					input: s,
					code: "too_small",
					minimum: -(2 ** 53 - 1),
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				});
				return;
			}
		}
		s < i && o.issues.push({
			origin: "number",
			input: s,
			code: "too_small",
			minimum: i,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		}), s > a && o.issues.push({
			origin: "number",
			input: s,
			code: "too_big",
			maximum: a,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		});
	};
}), In = /* @__PURE__ */ C("$ZodCheckMaxLength", (e, t) => {
	var n;
	I.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !dt(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag.maximum ?? Infinity;
		t.maximum < n && (e._zod.bag.maximum = t.maximum);
	}), e._zod.check = (n) => {
		let r = n.value;
		if (r.length <= t.maximum) return;
		let i = Pt(r);
		n.issues.push({
			origin: i,
			code: "too_big",
			maximum: t.maximum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), Ln = /* @__PURE__ */ C("$ZodCheckMinLength", (e, t) => {
	var n;
	I.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !dt(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag.minimum ?? -Infinity;
		t.minimum > n && (e._zod.bag.minimum = t.minimum);
	}), e._zod.check = (n) => {
		let r = n.value;
		if (r.length >= t.minimum) return;
		let i = Pt(r);
		n.issues.push({
			origin: i,
			code: "too_small",
			minimum: t.minimum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), Rn = /* @__PURE__ */ C("$ZodCheckLengthEquals", (e, t) => {
	var n;
	I.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !dt(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag;
		n.minimum = t.length, n.maximum = t.length, n.length = t.length;
	}), e._zod.check = (n) => {
		let r = n.value, i = r.length;
		if (i === t.length) return;
		let a = Pt(r), o = i > t.length;
		n.issues.push({
			origin: a,
			...o ? {
				code: "too_big",
				maximum: t.length
			} : {
				code: "too_small",
				minimum: t.length
			},
			inclusive: !0,
			exact: !0,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), zn = /* @__PURE__ */ C("$ZodCheckStringFormat", (e, t) => {
	var n, r;
	I.init(e, t), e._zod.onattach.push((e) => {
		let n = e._zod.bag;
		n.format = t.format, t.pattern && (n.patterns ??= /* @__PURE__ */ new Set(), n.patterns.add(t.pattern));
	}), t.pattern ? (n = e._zod).check ?? (n.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: t.format,
			input: n.value,
			...t.pattern ? { pattern: t.pattern.toString() } : {},
			inst: e,
			continue: !t.abort
		});
	}) : (r = e._zod).check ?? (r.check = () => {});
}), Bn = /* @__PURE__ */ C("$ZodCheckRegex", (e, t) => {
	zn.init(e, t), e._zod.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "regex",
			input: n.value,
			pattern: t.pattern.toString(),
			inst: e,
			continue: !t.abort
		});
	};
}), Vn = /* @__PURE__ */ C("$ZodCheckLowerCase", (e, t) => {
	t.pattern ??= kn, zn.init(e, t);
}), Hn = /* @__PURE__ */ C("$ZodCheckUpperCase", (e, t) => {
	t.pattern ??= An, zn.init(e, t);
}), Un = /* @__PURE__ */ C("$ZodCheckIncludes", (e, t) => {
	I.init(e, t);
	let n = A(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
	t.pattern = r, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(r);
	}), e._zod.check = (n) => {
		n.value.includes(t.includes, t.position) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "includes",
			includes: t.includes,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Wn = /* @__PURE__ */ C("$ZodCheckStartsWith", (e, t) => {
	I.init(e, t);
	let n = RegExp(`^${A(t.prefix)}.*`);
	t.pattern ??= n, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(n);
	}), e._zod.check = (n) => {
		n.value.startsWith(t.prefix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "starts_with",
			prefix: t.prefix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Gn = /* @__PURE__ */ C("$ZodCheckEndsWith", (e, t) => {
	I.init(e, t);
	let n = RegExp(`.*${A(t.suffix)}$`);
	t.pattern ??= n, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(n);
	}), e._zod.check = (n) => {
		n.value.endsWith(t.suffix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "ends_with",
			suffix: t.suffix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Kn = /* @__PURE__ */ C("$ZodCheckOverwrite", (e, t) => {
	I.init(e, t), e._zod.check = (e) => {
		e.value = t.tx(e.value);
	};
}), qn = class {
	constructor(e = []) {
		this.content = [], this.indent = 0, this && (this.args = e);
	}
	indented(e) {
		this.indent += 1, e(this), --this.indent;
	}
	write(e) {
		if (typeof e == "function") {
			e(this, { execution: "sync" }), e(this, { execution: "async" });
			return;
		}
		let t = e.split("\n").filter((e) => e), n = Math.min(...t.map((e) => e.length - e.trimStart().length)), r = t.map((e) => e.slice(n)).map((e) => " ".repeat(this.indent * 2) + e);
		for (let e of r) this.content.push(e);
	}
	compile() {
		let e = Function, t = this?.args, n = [...(this?.content ?? [""]).map((e) => `  ${e}`)];
		return new e(...t, n.join("\n"));
	}
}, Jn = {
	major: 4,
	minor: 4,
	patch: 3
}, L = /* @__PURE__ */ C("$ZodType", (e, t) => {
	var n;
	e ??= {}, e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Jn;
	let r = [...e._zod.def.checks ?? []];
	e._zod.traits.has("$ZodCheck") && r.unshift(e);
	for (let t of r) for (let n of t._zod.onattach) n(e);
	if (r.length === 0) (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
		e._zod.run = e._zod.parse;
	});
	else {
		let t = (e, t, n) => {
			let r = N(e), i;
			for (let a of t) {
				if (a._zod.def.when) {
					if (jt(e) || !a._zod.def.when(e)) continue;
				} else if (r) continue;
				let t = e.issues.length, o = a._zod.check(e);
				if (o instanceof Promise && n?.async === !1) throw new w();
				if (i || o instanceof Promise) i = (i ?? Promise.resolve()).then(async () => {
					await o, e.issues.length !== t && (r ||= N(e, t));
				});
				else {
					if (e.issues.length === t) continue;
					r ||= N(e, t);
				}
			}
			return i ? i.then(() => e) : e;
		}, n = (n, i, a) => {
			if (N(n)) return n.aborted = !0, n;
			let o = t(i, r, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new w();
				return o.then((t) => e._zod.parse(t, a));
			}
			return e._zod.parse(o, a);
		};
		e._zod.run = (i, a) => {
			if (a.skipChecks) return e._zod.parse(i, a);
			if (a.direction === "backward") {
				let t = e._zod.parse({
					value: i.value,
					issues: []
				}, {
					...a,
					skipChecks: !0
				});
				return t instanceof Promise ? t.then((e) => n(e, i, a)) : n(t, i, a);
			}
			let o = e._zod.parse(i, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new w();
				return o.then((e) => t(e, r, a));
			}
			return t(o, r, a);
		};
	}
	E(e, "~standard", () => ({
		validate: (t) => {
			try {
				let n = Ut(e, t);
				return n.success ? { value: n.data } : { issues: n.error?.issues };
			} catch {
				return Gt(e, t).then((e) => e.success ? { value: e.data } : { issues: e.error?.issues });
			}
		},
		vendor: "zod",
		version: 1
	}));
}), Yn = /* @__PURE__ */ C("$ZodString", (e, t) => {
	L.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? En(e._zod.bag), e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = String(n.value);
		} catch {}
		return typeof n.value == "string" || n.issues.push({
			expected: "string",
			code: "invalid_type",
			input: n.value,
			inst: e
		}), n;
	};
}), R = /* @__PURE__ */ C("$ZodStringFormat", (e, t) => {
	zn.init(e, t), Yn.init(e, t);
}), Xn = /* @__PURE__ */ C("$ZodGUID", (e, t) => {
	t.pattern ??= cn, R.init(e, t);
}), Zn = /* @__PURE__ */ C("$ZodUUID", (e, t) => {
	if (t.version) {
		let e = {
			v1: 1,
			v2: 2,
			v3: 3,
			v4: 4,
			v5: 5,
			v6: 6,
			v7: 7,
			v8: 8
		}[t.version];
		if (e === void 0) throw Error(`Invalid UUID version: "${t.version}"`);
		t.pattern ??= ln(e);
	} else t.pattern ??= ln();
	R.init(e, t);
}), Qn = /* @__PURE__ */ C("$ZodEmail", (e, t) => {
	t.pattern ??= un, R.init(e, t);
}), $n = /* @__PURE__ */ C("$ZodURL", (e, t) => {
	R.init(e, t), e._zod.check = (n) => {
		try {
			let r = n.value.trim();
			if (!t.normalize && t.protocol?.source === yn.source && !/^https?:\/\//i.test(r)) {
				n.issues.push({
					code: "invalid_format",
					format: "url",
					note: "Invalid URL format",
					input: n.value,
					inst: e,
					continue: !t.abort
				});
				return;
			}
			let i = new URL(r);
			t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid hostname",
				pattern: t.hostname.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			})), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid protocol",
				pattern: t.protocol.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			})), t.normalize ? n.value = i.href : n.value = r;
			return;
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "url",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), er = /* @__PURE__ */ C("$ZodEmoji", (e, t) => {
	t.pattern ??= fn(), R.init(e, t);
}), tr = /* @__PURE__ */ C("$ZodNanoID", (e, t) => {
	t.pattern ??= on, R.init(e, t);
}), nr = /* @__PURE__ */ C("$ZodCUID", (e, t) => {
	t.pattern ??= en, R.init(e, t);
}), rr = /* @__PURE__ */ C("$ZodCUID2", (e, t) => {
	t.pattern ??= tn, R.init(e, t);
}), ir = /* @__PURE__ */ C("$ZodULID", (e, t) => {
	t.pattern ??= nn, R.init(e, t);
}), ar = /* @__PURE__ */ C("$ZodXID", (e, t) => {
	t.pattern ??= rn, R.init(e, t);
}), or = /* @__PURE__ */ C("$ZodKSUID", (e, t) => {
	t.pattern ??= an, R.init(e, t);
}), sr = /* @__PURE__ */ C("$ZodISODateTime", (e, t) => {
	t.pattern ??= Tn(t), R.init(e, t);
}), cr = /* @__PURE__ */ C("$ZodISODate", (e, t) => {
	t.pattern ??= Sn, R.init(e, t);
}), lr = /* @__PURE__ */ C("$ZodISOTime", (e, t) => {
	t.pattern ??= wn(t), R.init(e, t);
}), ur = /* @__PURE__ */ C("$ZodISODuration", (e, t) => {
	t.pattern ??= sn, R.init(e, t);
}), dr = /* @__PURE__ */ C("$ZodIPv4", (e, t) => {
	t.pattern ??= pn, R.init(e, t), e._zod.bag.format = "ipv4";
}), fr = /* @__PURE__ */ C("$ZodIPv6", (e, t) => {
	t.pattern ??= mn, R.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
		try {
			new URL(`http://[${n.value}]`);
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "ipv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), pr = /* @__PURE__ */ C("$ZodCIDRv4", (e, t) => {
	t.pattern ??= hn, R.init(e, t);
}), mr = /* @__PURE__ */ C("$ZodCIDRv6", (e, t) => {
	t.pattern ??= gn, R.init(e, t), e._zod.check = (n) => {
		let r = n.value.split("/");
		try {
			if (r.length !== 2) throw Error();
			let [e, t] = r;
			if (!t) throw Error();
			let n = Number(t);
			if (`${n}` !== t || n < 0 || n > 128) throw Error();
			new URL(`http://[${e}]`);
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "cidrv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
});
function hr(e) {
	if (e === "") return !0;
	if (/\s/.test(e) || e.length % 4 != 0) return !1;
	try {
		return atob(e), !0;
	} catch {
		return !1;
	}
}
var gr = /* @__PURE__ */ C("$ZodBase64", (e, t) => {
	t.pattern ??= _n, R.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
		hr(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
});
function _r(e) {
	if (!vn.test(e)) return !1;
	let t = e.replace(/[-_]/g, (e) => e === "-" ? "+" : "/");
	return hr(t.padEnd(Math.ceil(t.length / 4) * 4, "="));
}
var vr = /* @__PURE__ */ C("$ZodBase64URL", (e, t) => {
	t.pattern ??= vn, R.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
		_r(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64url",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), yr = /* @__PURE__ */ C("$ZodE164", (e, t) => {
	t.pattern ??= bn, R.init(e, t);
});
function br(e, t = null) {
	try {
		let n = e.split(".");
		if (n.length !== 3) return !1;
		let [r] = n;
		if (!r) return !1;
		let i = JSON.parse(atob(r));
		return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
	} catch {
		return !1;
	}
}
var xr = /* @__PURE__ */ C("$ZodJWT", (e, t) => {
	R.init(e, t), e._zod.check = (n) => {
		br(n.value, t.alg) || n.issues.push({
			code: "invalid_format",
			format: "jwt",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Sr = /* @__PURE__ */ C("$ZodNumber", (e, t) => {
	L.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? On, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = Number(n.value);
		} catch {}
		let i = n.value;
		if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i)) return n;
		let a = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
		return n.issues.push({
			expected: "number",
			code: "invalid_type",
			input: i,
			inst: e,
			...a ? { received: a } : {}
		}), n;
	};
}), Cr = /* @__PURE__ */ C("$ZodNumberFormat", (e, t) => {
	Fn.init(e, t), Sr.init(e, t);
}), wr = /* @__PURE__ */ C("$ZodUnknown", (e, t) => {
	L.init(e, t), e._zod.parse = (e) => e;
}), Tr = /* @__PURE__ */ C("$ZodNever", (e, t) => {
	L.init(e, t), e._zod.parse = (t, n) => (t.issues.push({
		expected: "never",
		code: "invalid_type",
		input: t.value,
		inst: e
	}), t);
});
function Er(e, t, n) {
	e.issues.length && t.issues.push(...Mt(n, e.issues)), t.value[n] = e.value;
}
var Dr = /* @__PURE__ */ C("$ZodArray", (e, t) => {
	L.init(e, t), e._zod.parse = (n, r) => {
		let i = n.value;
		if (!Array.isArray(i)) return n.issues.push({
			expected: "array",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
		n.value = Array(i.length);
		let a = [];
		for (let e = 0; e < i.length; e++) {
			let o = i[e], s = t.element._zod.run({
				value: o,
				issues: []
			}, r);
			s instanceof Promise ? a.push(s.then((t) => Er(t, n, e))) : Er(s, n, e);
		}
		return a.length ? Promise.all(a).then(() => n) : n;
	};
});
function Or(e, t, n, r, i, a) {
	let o = n in r;
	if (e.issues.length) {
		if (i && a && !o) return;
		t.issues.push(...Mt(n, e.issues));
	}
	if (!o && !i) {
		e.issues.length || t.issues.push({
			code: "invalid_type",
			expected: "nonoptional",
			input: void 0,
			path: [n]
		});
		return;
	}
	e.value === void 0 ? o && (t.value[n] = void 0) : t.value[n] = e.value;
}
function kr(e) {
	let t = Object.keys(e.shape);
	for (let n of t) if (!e.shape?.[n]?._zod?.traits?.has("$ZodType")) throw Error(`Invalid element at key "${n}": expected a Zod schema`);
	let n = St(e.shape);
	return {
		...e,
		keys: t,
		keySet: new Set(t),
		numKeys: t.length,
		optionalKeys: new Set(n)
	};
}
function Ar(e, t, n, r, i, a) {
	let o = [], s = i.keySet, c = i.catchall._zod, l = c.def.type, u = c.optin === "optional", d = c.optout === "optional";
	for (let i in t) {
		if (i === "__proto__" || s.has(i)) continue;
		if (l === "never") {
			o.push(i);
			continue;
		}
		let a = c.run({
			value: t[i],
			issues: []
		}, r);
		a instanceof Promise ? e.push(a.then((e) => Or(e, n, i, t, u, d))) : Or(a, n, i, t, u, d);
	}
	return o.length && n.issues.push({
		code: "unrecognized_keys",
		keys: o,
		input: t,
		inst: a
	}), e.length ? Promise.all(e).then(() => n) : n;
}
var jr = /* @__PURE__ */ C("$ZodObject", (e, t) => {
	if (L.init(e, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
		let e = t.shape;
		Object.defineProperty(t, "shape", { get: () => {
			let n = { ...e };
			return Object.defineProperty(t, "shape", { value: n }), n;
		} });
	}
	let n = ut(() => kr(t));
	E(e._zod, "propValues", () => {
		let e = t.shape, n = {};
		for (let t in e) {
			let r = e[t]._zod;
			if (r.values) {
				n[t] ?? (n[t] = /* @__PURE__ */ new Set());
				for (let e of r.values) n[t].add(e);
			}
		}
		return n;
	});
	let r = vt, i = t.catchall, a;
	e._zod.parse = (t, o) => {
		a ??= n.value;
		let s = t.value;
		if (!r(s)) return t.issues.push({
			expected: "object",
			code: "invalid_type",
			input: s,
			inst: e
		}), t;
		t.value = {};
		let c = [], l = a.shape;
		for (let e of a.keys) {
			let n = l[e], r = n._zod.optin === "optional", i = n._zod.optout === "optional", a = n._zod.run({
				value: s[e],
				issues: []
			}, o);
			a instanceof Promise ? c.push(a.then((n) => Or(n, t, e, s, r, i))) : Or(a, t, e, s, r, i);
		}
		return i ? Ar(c, s, t, o, n.value, e) : c.length ? Promise.all(c).then(() => t) : t;
	};
}), Mr = /* @__PURE__ */ C("$ZodObjectJIT", (e, t) => {
	jr.init(e, t);
	let n = e._zod.parse, r = ut(() => kr(t)), i = (e) => {
		let t = new qn([
			"shape",
			"payload",
			"ctx"
		]), n = r.value, i = (e) => {
			let t = ht(e);
			return `shape[${t}]._zod.run({ value: input[${t}], issues: [] }, ctx)`;
		};
		t.write("const input = payload.value;");
		let a = Object.create(null), o = 0;
		for (let e of n.keys) a[e] = `key_${o++}`;
		t.write("const newResult = {};");
		for (let r of n.keys) {
			let n = a[r], o = ht(r), s = e[r], c = s?._zod?.optin === "optional", l = s?._zod?.optout === "optional";
			t.write(`const ${n} = ${i(r)};`), c && l ? t.write(`
        if (${n}.issues.length) {
          if (${o} in input) {
            payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${o}, ...iss.path] : [${o}]
            })));
          }
        }
        
        if (${n}.value === undefined) {
          if (${o} in input) {
            newResult[${o}] = undefined;
          }
        } else {
          newResult[${o}] = ${n}.value;
        }
        
      `) : c ? t.write(`
        if (${n}.issues.length) {
          payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${o}, ...iss.path] : [${o}]
          })));
        }
        
        if (${n}.value === undefined) {
          if (${o} in input) {
            newResult[${o}] = undefined;
          }
        } else {
          newResult[${o}] = ${n}.value;
        }
        
      `) : t.write(`
        const ${n}_present = ${o} in input;
        if (${n}.issues.length) {
          payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${o}, ...iss.path] : [${o}]
          })));
        }
        if (!${n}_present && !${n}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${o}]
          });
        }

        if (${n}_present) {
          if (${n}.value === undefined) {
            newResult[${o}] = undefined;
          } else {
            newResult[${o}] = ${n}.value;
          }
        }

      `);
		}
		t.write("payload.value = newResult;"), t.write("return payload;");
		let s = t.compile();
		return (t, n) => s(e, t, n);
	}, a, o = vt, s = !st.jitless, c = s && yt.value, l = t.catchall, u;
	e._zod.parse = (d, f) => {
		u ??= r.value;
		let p = d.value;
		return o(p) ? s && c && f?.async === !1 && f.jitless !== !0 ? (a ||= i(t.shape), d = a(d, f), l ? Ar([], p, d, f, u, e) : d) : n(d, f) : (d.issues.push({
			expected: "object",
			code: "invalid_type",
			input: p,
			inst: e
		}), d);
	};
});
function Nr(e, t, n, r) {
	for (let n of e) if (n.issues.length === 0) return t.value = n.value, t;
	let i = e.filter((e) => !N(e));
	return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
		code: "invalid_union",
		input: t.value,
		inst: n,
		errors: e.map((e) => e.issues.map((e) => P(e, r, T())))
	}), t);
}
var Pr = /* @__PURE__ */ C("$ZodUnion", (e, t) => {
	L.init(e, t), E(e._zod, "optin", () => t.options.some((e) => e._zod.optin === "optional") ? "optional" : void 0), E(e._zod, "optout", () => t.options.some((e) => e._zod.optout === "optional") ? "optional" : void 0), E(e._zod, "values", () => {
		if (t.options.every((e) => e._zod.values)) return new Set(t.options.flatMap((e) => Array.from(e._zod.values)));
	}), E(e._zod, "pattern", () => {
		if (t.options.every((e) => e._zod.pattern)) {
			let e = t.options.map((e) => e._zod.pattern);
			return RegExp(`^(${e.map((e) => ft(e.source)).join("|")})$`);
		}
	});
	let n = t.options.length === 1 ? t.options[0]._zod.run : null;
	e._zod.parse = (r, i) => {
		if (n) return n(r, i);
		let a = !1, o = [];
		for (let e of t.options) {
			let t = e._zod.run({
				value: r.value,
				issues: []
			}, i);
			if (t instanceof Promise) o.push(t), a = !0;
			else {
				if (t.issues.length === 0) return t;
				o.push(t);
			}
		}
		return a ? Promise.all(o).then((t) => Nr(t, r, e, i)) : Nr(o, r, e, i);
	};
}), Fr = /* @__PURE__ */ C("$ZodDiscriminatedUnion", (e, t) => {
	t.inclusive = !1, Pr.init(e, t);
	let n = e._zod.parse;
	E(e._zod, "propValues", () => {
		let e = {};
		for (let n of t.options) {
			let r = n._zod.propValues;
			if (!r || Object.keys(r).length === 0) throw Error(`Invalid discriminated union option at index "${t.options.indexOf(n)}"`);
			for (let [t, n] of Object.entries(r)) {
				e[t] || (e[t] = /* @__PURE__ */ new Set());
				for (let r of n) e[t].add(r);
			}
		}
		return e;
	});
	let r = ut(() => {
		let e = t.options, n = /* @__PURE__ */ new Map();
		for (let r of e) {
			let e = r._zod.propValues?.[t.discriminator];
			if (!e || e.size === 0) throw Error(`Invalid discriminated union option at index "${t.options.indexOf(r)}"`);
			for (let t of e) {
				if (n.has(t)) throw Error(`Duplicate discriminator value "${String(t)}"`);
				n.set(t, r);
			}
		}
		return n;
	});
	e._zod.parse = (i, a) => {
		let o = i.value;
		if (!vt(o)) return i.issues.push({
			code: "invalid_type",
			expected: "object",
			input: o,
			inst: e
		}), i;
		let s = r.value.get(o?.[t.discriminator]);
		return s ? s._zod.run(i, a) : t.unionFallback || a.direction === "backward" ? n(i, a) : (i.issues.push({
			code: "invalid_union",
			errors: [],
			note: "No matching discriminator",
			discriminator: t.discriminator,
			options: Array.from(r.value.keys()),
			input: o,
			path: [t.discriminator],
			inst: e
		}), i);
	};
}), Ir = /* @__PURE__ */ C("$ZodIntersection", (e, t) => {
	L.init(e, t), e._zod.parse = (e, n) => {
		let r = e.value, i = t.left._zod.run({
			value: r,
			issues: []
		}, n), a = t.right._zod.run({
			value: r,
			issues: []
		}, n);
		return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([t, n]) => Rr(e, t, n)) : Rr(e, i, a);
	};
});
function Lr(e, t) {
	if (e === t || e instanceof Date && t instanceof Date && +e == +t) return {
		valid: !0,
		data: e
	};
	if (k(e) && k(t)) {
		let n = Object.keys(t), r = Object.keys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		for (let n of r) {
			let r = Lr(e[n], t[n]);
			if (!r.valid) return {
				valid: !1,
				mergeErrorPath: [n, ...r.mergeErrorPath]
			};
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	}
	if (Array.isArray(e) && Array.isArray(t)) {
		if (e.length !== t.length) return {
			valid: !1,
			mergeErrorPath: []
		};
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = Lr(i, a);
			if (!o.valid) return {
				valid: !1,
				mergeErrorPath: [r, ...o.mergeErrorPath]
			};
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	}
	return {
		valid: !1,
		mergeErrorPath: []
	};
}
function Rr(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i;
	for (let n of t.issues) if (n.code === "unrecognized_keys") {
		i ??= n;
		for (let e of n.keys) r.has(e) || r.set(e, {}), r.get(e).l = !0;
	} else e.issues.push(n);
	for (let t of n.issues) if (t.code === "unrecognized_keys") for (let e of t.keys) r.has(e) || r.set(e, {}), r.get(e).r = !0;
	else e.issues.push(t);
	let a = [...r].filter(([, e]) => e.l && e.r).map(([e]) => e);
	if (a.length && i && e.issues.push({
		...i,
		keys: a
	}), N(e)) return e;
	let o = Lr(t.value, n.value);
	if (!o.valid) throw Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
	return e.value = o.data, e;
}
var zr = /* @__PURE__ */ C("$ZodEnum", (e, t) => {
	L.init(e, t);
	let n = ct(t.entries), r = new Set(n);
	e._zod.values = r, e._zod.pattern = RegExp(`^(${n.filter((e) => xt.has(typeof e)).map((e) => typeof e == "string" ? A(e) : e.toString()).join("|")})$`), e._zod.parse = (t, i) => {
		let a = t.value;
		return r.has(a) || t.issues.push({
			code: "invalid_value",
			values: n,
			input: a,
			inst: e
		}), t;
	};
}), Br = /* @__PURE__ */ C("$ZodLiteral", (e, t) => {
	if (L.init(e, t), t.values.length === 0) throw Error("Cannot create literal schema with no valid values");
	let n = new Set(t.values);
	e._zod.values = n, e._zod.pattern = RegExp(`^(${t.values.map((e) => typeof e == "string" ? A(e) : e ? A(e.toString()) : String(e)).join("|")})$`), e._zod.parse = (r, i) => {
		let a = r.value;
		return n.has(a) || r.issues.push({
			code: "invalid_value",
			values: t.values,
			input: a,
			inst: e
		}), r;
	};
}), Vr = /* @__PURE__ */ C("$ZodTransform", (e, t) => {
	L.init(e, t), e._zod.optin = "optional", e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new ot(e.constructor.name);
		let i = t.transform(n.value, n);
		if (r.async) return (i instanceof Promise ? i : Promise.resolve(i)).then((e) => (n.value = e, n.fallback = !0, n));
		if (i instanceof Promise) throw new w();
		return n.value = i, n.fallback = !0, n;
	};
});
function Hr(e, t) {
	return t === void 0 && (e.issues.length || e.fallback) ? {
		issues: [],
		value: void 0
	} : e;
}
var Ur = /* @__PURE__ */ C("$ZodOptional", (e, t) => {
	L.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", E(e._zod, "values", () => t.innerType._zod.values ? new Set([...t.innerType._zod.values, void 0]) : void 0), E(e._zod, "pattern", () => {
		let e = t.innerType._zod.pattern;
		return e ? RegExp(`^(${ft(e.source)})?$`) : void 0;
	}), e._zod.parse = (e, n) => {
		if (t.innerType._zod.optin === "optional") {
			let r = e.value, i = t.innerType._zod.run(e, n);
			return i instanceof Promise ? i.then((e) => Hr(e, r)) : Hr(i, r);
		}
		return e.value === void 0 ? e : t.innerType._zod.run(e, n);
	};
}), Wr = /* @__PURE__ */ C("$ZodExactOptional", (e, t) => {
	Ur.init(e, t), E(e._zod, "values", () => t.innerType._zod.values), E(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (e, n) => t.innerType._zod.run(e, n);
}), Gr = /* @__PURE__ */ C("$ZodNullable", (e, t) => {
	L.init(e, t), E(e._zod, "optin", () => t.innerType._zod.optin), E(e._zod, "optout", () => t.innerType._zod.optout), E(e._zod, "pattern", () => {
		let e = t.innerType._zod.pattern;
		return e ? RegExp(`^(${ft(e.source)}|null)$`) : void 0;
	}), E(e._zod, "values", () => t.innerType._zod.values ? new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (e, n) => e.value === null ? e : t.innerType._zod.run(e, n);
}), Kr = /* @__PURE__ */ C("$ZodDefault", (e, t) => {
	L.init(e, t), e._zod.optin = "optional", E(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		if (e.value === void 0) return e.value = t.defaultValue, e;
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => qr(e, t)) : qr(r, t);
	};
});
function qr(e, t) {
	return e.value === void 0 && (e.value = t.defaultValue), e;
}
var Jr = /* @__PURE__ */ C("$ZodPrefault", (e, t) => {
	L.init(e, t), e._zod.optin = "optional", E(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => (n.direction === "backward" || e.value === void 0 && (e.value = t.defaultValue), t.innerType._zod.run(e, n));
}), Yr = /* @__PURE__ */ C("$ZodNonOptional", (e, t) => {
	L.init(e, t), E(e._zod, "values", () => {
		let e = t.innerType._zod.values;
		return e ? new Set([...e].filter((e) => e !== void 0)) : void 0;
	}), e._zod.parse = (n, r) => {
		let i = t.innerType._zod.run(n, r);
		return i instanceof Promise ? i.then((t) => Xr(t, e)) : Xr(i, e);
	};
});
function Xr(e, t) {
	return !e.issues.length && e.value === void 0 && e.issues.push({
		code: "invalid_type",
		expected: "nonoptional",
		input: e.value,
		inst: t
	}), e;
}
var Zr = /* @__PURE__ */ C("$ZodCatch", (e, t) => {
	L.init(e, t), e._zod.optin = "optional", E(e._zod, "optout", () => t.innerType._zod.optout), E(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((r) => (e.value = r.value, r.issues.length && (e.value = t.catchValue({
			...e,
			error: { issues: r.issues.map((e) => P(e, n, T())) },
			input: e.value
		}), e.issues = [], e.fallback = !0), e)) : (e.value = r.value, r.issues.length && (e.value = t.catchValue({
			...e,
			error: { issues: r.issues.map((e) => P(e, n, T())) },
			input: e.value
		}), e.issues = [], e.fallback = !0), e);
	};
}), Qr = /* @__PURE__ */ C("$ZodPipe", (e, t) => {
	L.init(e, t), E(e._zod, "values", () => t.in._zod.values), E(e._zod, "optin", () => t.in._zod.optin), E(e._zod, "optout", () => t.out._zod.optout), E(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (e, n) => {
		if (n.direction === "backward") {
			let r = t.out._zod.run(e, n);
			return r instanceof Promise ? r.then((e) => $r(e, t.in, n)) : $r(r, t.in, n);
		}
		let r = t.in._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => $r(e, t.out, n)) : $r(r, t.out, n);
	};
});
function $r(e, t, n) {
	return e.issues.length ? (e.aborted = !0, e) : t._zod.run({
		value: e.value,
		issues: e.issues,
		fallback: e.fallback
	}, n);
}
var ei = /* @__PURE__ */ C("$ZodReadonly", (e, t) => {
	L.init(e, t), E(e._zod, "propValues", () => t.innerType._zod.propValues), E(e._zod, "values", () => t.innerType._zod.values), E(e._zod, "optin", () => t.innerType?._zod?.optin), E(e._zod, "optout", () => t.innerType?._zod?.optout), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then(ti) : ti(r);
	};
});
function ti(e) {
	return e.value = Object.freeze(e.value), e;
}
var ni = /* @__PURE__ */ C("$ZodCustom", (e, t) => {
	I.init(e, t), L.init(e, t), e._zod.parse = (e, t) => e, e._zod.check = (n) => {
		let r = n.value, i = t.fn(r);
		if (i instanceof Promise) return i.then((t) => ri(t, n, r, e));
		ri(i, n, r, e);
	};
});
function ri(e, t, n, r) {
	if (!e) {
		let e = {
			code: "custom",
			input: n,
			inst: r,
			path: [...r._zod.def.path ?? []],
			continue: !r._zod.def.abort
		};
		r._zod.def.params && (e.params = r._zod.def.params), t.issues.push(F(e));
	}
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.4.3/node_modules/zod/v4/core/registries.js
var ii, ai = class {
	constructor() {
		this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
	}
	add(e, ...t) {
		let n = t[0];
		return this._map.set(e, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, e), this;
	}
	clear() {
		return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
	}
	remove(e) {
		let t = this._map.get(e);
		return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(e), this;
	}
	get(e) {
		let t = e._zod.parent;
		if (t) {
			let n = { ...this.get(t) ?? {} };
			delete n.id;
			let r = {
				...n,
				...this._map.get(e)
			};
			return Object.keys(r).length ? r : void 0;
		}
		return this._map.get(e);
	}
	has(e) {
		return this._map.has(e);
	}
};
function oi() {
	return new ai();
}
(ii = globalThis).__zod_globalRegistry ?? (ii.__zod_globalRegistry = oi());
var si = globalThis.__zod_globalRegistry;
//#endregion
//#region ../../node_modules/.pnpm/zod@4.4.3/node_modules/zod/v4/core/api.js
/* @__NO_SIDE_EFFECTS__ */
function ci(e, t) {
	return new e({
		type: "string",
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function li(e, t) {
	return new e({
		type: "string",
		format: "email",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function ui(e, t) {
	return new e({
		type: "string",
		format: "guid",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function di(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function fi(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v4",
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function pi(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v6",
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function mi(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v7",
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function hi(e, t) {
	return new e({
		type: "string",
		format: "url",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function gi(e, t) {
	return new e({
		type: "string",
		format: "emoji",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function _i(e, t) {
	return new e({
		type: "string",
		format: "nanoid",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function vi(e, t) {
	return new e({
		type: "string",
		format: "cuid",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function yi(e, t) {
	return new e({
		type: "string",
		format: "cuid2",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function bi(e, t) {
	return new e({
		type: "string",
		format: "ulid",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function xi(e, t) {
	return new e({
		type: "string",
		format: "xid",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Si(e, t) {
	return new e({
		type: "string",
		format: "ksuid",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ci(e, t) {
	return new e({
		type: "string",
		format: "ipv4",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function wi(e, t) {
	return new e({
		type: "string",
		format: "ipv6",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ti(e, t) {
	return new e({
		type: "string",
		format: "cidrv4",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ei(e, t) {
	return new e({
		type: "string",
		format: "cidrv6",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Di(e, t) {
	return new e({
		type: "string",
		format: "base64",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Oi(e, t) {
	return new e({
		type: "string",
		format: "base64url",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function ki(e, t) {
	return new e({
		type: "string",
		format: "e164",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ai(e, t) {
	return new e({
		type: "string",
		format: "jwt",
		check: "string_format",
		abort: !1,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function ji(e, t) {
	return new e({
		type: "string",
		format: "datetime",
		check: "string_format",
		offset: !1,
		local: !1,
		precision: null,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Mi(e, t) {
	return new e({
		type: "string",
		format: "date",
		check: "string_format",
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ni(e, t) {
	return new e({
		type: "string",
		format: "time",
		check: "string_format",
		precision: null,
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Pi(e, t) {
	return new e({
		type: "string",
		format: "duration",
		check: "string_format",
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Fi(e, t) {
	return new e({
		type: "number",
		checks: [],
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ii(e, t) {
	return new e({
		type: "number",
		check: "number_format",
		abort: !1,
		format: "safeint",
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Li(e) {
	return new e({ type: "unknown" });
}
/* @__NO_SIDE_EFFECTS__ */
function Ri(e, t) {
	return new e({
		type: "never",
		...M(t)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function zi(e, t) {
	return new Mn({
		check: "less_than",
		...M(t),
		value: e,
		inclusive: !1
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Bi(e, t) {
	return new Mn({
		check: "less_than",
		...M(t),
		value: e,
		inclusive: !0
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Vi(e, t) {
	return new Nn({
		check: "greater_than",
		...M(t),
		value: e,
		inclusive: !1
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Hi(e, t) {
	return new Nn({
		check: "greater_than",
		...M(t),
		value: e,
		inclusive: !0
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ui(e, t) {
	return new Pn({
		check: "multiple_of",
		...M(t),
		value: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Wi(e, t) {
	return new In({
		check: "max_length",
		...M(t),
		maximum: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Gi(e, t) {
	return new Ln({
		check: "min_length",
		...M(t),
		minimum: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ki(e, t) {
	return new Rn({
		check: "length_equals",
		...M(t),
		length: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function qi(e, t) {
	return new Bn({
		check: "string_format",
		format: "regex",
		...M(t),
		pattern: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Ji(e) {
	return new Vn({
		check: "string_format",
		format: "lowercase",
		...M(e)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Yi(e) {
	return new Hn({
		check: "string_format",
		format: "uppercase",
		...M(e)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Xi(e, t) {
	return new Un({
		check: "string_format",
		format: "includes",
		...M(t),
		includes: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Zi(e, t) {
	return new Wn({
		check: "string_format",
		format: "starts_with",
		...M(t),
		prefix: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function Qi(e, t) {
	return new Gn({
		check: "string_format",
		format: "ends_with",
		...M(t),
		suffix: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function z(e) {
	return new Kn({
		check: "overwrite",
		tx: e
	});
}
/* @__NO_SIDE_EFFECTS__ */
function $i(e) {
	return /* @__PURE__ */ z((t) => t.normalize(e));
}
/* @__NO_SIDE_EFFECTS__ */
function ea() {
	return /* @__PURE__ */ z((e) => e.trim());
}
/* @__NO_SIDE_EFFECTS__ */
function ta() {
	return /* @__PURE__ */ z((e) => e.toLowerCase());
}
/* @__NO_SIDE_EFFECTS__ */
function na() {
	return /* @__PURE__ */ z((e) => e.toUpperCase());
}
/* @__NO_SIDE_EFFECTS__ */
function ra() {
	return /* @__PURE__ */ z((e) => gt(e));
}
/* @__NO_SIDE_EFFECTS__ */
function ia(e, t, n) {
	return new e({
		type: "array",
		element: t,
		...M(n)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function aa(e, t, n) {
	return new e({
		type: "custom",
		check: "custom",
		fn: t,
		...M(n)
	});
}
/* @__NO_SIDE_EFFECTS__ */
function oa(e, t) {
	let n = /* @__PURE__ */ sa((t) => (t.addIssue = (e) => {
		if (typeof e == "string") t.issues.push(F(e, t.value, n._zod.def));
		else {
			let r = e;
			r.fatal && (r.continue = !1), r.code ??= "custom", r.input ??= t.value, r.inst ??= n, r.continue ??= !n._zod.def.abort, t.issues.push(F(r));
		}
	}, e(t.value, t)), t);
	return n;
}
/* @__NO_SIDE_EFFECTS__ */
function sa(e, t) {
	let n = new I({
		check: "custom",
		...M(t)
	});
	return n._zod.check = e, n;
}
//#endregion
//#region ../../node_modules/.pnpm/zod@4.4.3/node_modules/zod/v4/core/to-json-schema.js
function ca(e) {
	let t = e?.target ?? "draft-2020-12";
	return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
		processors: e.processors ?? {},
		metadataRegistry: e?.metadata ?? si,
		target: t,
		unrepresentable: e?.unrepresentable ?? "throw",
		override: e?.override ?? (() => {}),
		io: e?.io ?? "output",
		counter: 0,
		seen: /* @__PURE__ */ new Map(),
		cycles: e?.cycles ?? "ref",
		reused: e?.reused ?? "inline",
		external: e?.external ?? void 0
	};
}
function B(e, t, n = {
	path: [],
	schemaPath: []
}) {
	var r;
	let i = e._zod.def, a = t.seen.get(e);
	if (a) return a.count++, n.schemaPath.includes(e) && (a.cycle = n.path), a.schema;
	let o = {
		schema: {},
		count: 1,
		cycle: void 0,
		path: n.path
	};
	t.seen.set(e, o);
	let s = e._zod.toJSONSchema?.();
	if (s) o.schema = s;
	else {
		let r = {
			...n,
			schemaPath: [...n.schemaPath, e],
			path: n.path
		};
		if (e._zod.processJSONSchema) e._zod.processJSONSchema(t, o.schema, r);
		else {
			let n = o.schema, a = t.processors[i.type];
			if (!a) throw Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
			a(e, t, n, r);
		}
		let a = e._zod.parent;
		a && (o.ref ||= a, B(a, t, r), t.seen.get(a).isParent = !0);
	}
	let c = t.metadataRegistry.get(e);
	return c && Object.assign(o.schema, c), t.io === "input" && V(e) && (delete o.schema.examples, delete o.schema.default), t.io === "input" && "_prefault" in o.schema && ((r = o.schema).default ?? (r.default = o.schema._prefault)), delete o.schema._prefault, t.seen.get(e).schema;
}
function la(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = /* @__PURE__ */ new Map();
	for (let t of e.seen.entries()) {
		let n = e.metadataRegistry.get(t[0])?.id;
		if (n) {
			let e = r.get(n);
			if (e && e !== t[0]) throw Error(`Duplicate schema id "${n}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
			r.set(n, t[0]);
		}
	}
	let i = (t) => {
		let r = e.target === "draft-2020-12" ? "$defs" : "definitions";
		if (e.external) {
			let n = e.external.registry.get(t[0])?.id, i = e.external.uri ?? ((e) => e);
			if (n) return { ref: i(n) };
			let a = t[1].defId ?? t[1].schema.id ?? `schema${e.counter++}`;
			return t[1].defId = a, {
				defId: a,
				ref: `${i("__shared")}#/${r}/${a}`
			};
		}
		if (t[1] === n) return { ref: "#" };
		let i = `#/${r}/`, a = t[1].schema.id ?? `__schema${e.counter++}`;
		return {
			defId: a,
			ref: i + a
		};
	}, a = (e) => {
		if (e[1].schema.$ref) return;
		let t = e[1], { ref: n, defId: r } = i(e);
		t.def = { ...t.schema }, r && (t.defId = r);
		let a = t.schema;
		for (let e in a) delete a[e];
		a.$ref = n;
	};
	if (e.cycles === "throw") for (let t of e.seen.entries()) {
		let e = t[1];
		if (e.cycle) throw Error(`Cycle detected: #/${e.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
	}
	for (let n of e.seen.entries()) {
		let r = n[1];
		if (t === n[0]) {
			a(n);
			continue;
		}
		if (e.external) {
			let r = e.external.registry.get(n[0])?.id;
			if (t !== n[0] && r) {
				a(n);
				continue;
			}
		}
		if (e.metadataRegistry.get(n[0])?.id) {
			a(n);
			continue;
		}
		if (r.cycle) {
			a(n);
			continue;
		}
		if (r.count > 1 && e.reused === "ref") {
			a(n);
			continue;
		}
	}
}
function ua(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = (t) => {
		let n = e.seen.get(t);
		if (n.ref === null) return;
		let i = n.def ?? n.schema, a = { ...i }, o = n.ref;
		if (n.ref = null, o) {
			r(o);
			let n = e.seen.get(o), s = n.schema;
			if (s.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (i.allOf = i.allOf ?? [], i.allOf.push(s)) : Object.assign(i, s), Object.assign(i, a), t._zod.parent === o) for (let e in i) e === "$ref" || e === "allOf" || e in a || delete i[e];
			if (s.$ref && n.def) for (let e in i) e === "$ref" || e === "allOf" || e in n.def && JSON.stringify(i[e]) === JSON.stringify(n.def[e]) && delete i[e];
		}
		let s = t._zod.parent;
		if (s && s !== o) {
			r(s);
			let t = e.seen.get(s);
			if (t?.schema.$ref && (i.$ref = t.schema.$ref, t.def)) for (let e in i) e === "$ref" || e === "allOf" || e in t.def && JSON.stringify(i[e]) === JSON.stringify(t.def[e]) && delete i[e];
		}
		e.override({
			zodSchema: t,
			jsonSchema: i,
			path: n.path ?? []
		});
	};
	for (let t of [...e.seen.entries()].reverse()) r(t[0]);
	let i = {};
	if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
		let n = e.external.registry.get(t)?.id;
		if (!n) throw Error("Schema is missing an `id` property");
		i.$id = e.external.uri(n);
	}
	Object.assign(i, n.def ?? n.schema);
	let a = e.metadataRegistry.get(t)?.id;
	a !== void 0 && i.id === a && delete i.id;
	let o = e.external?.defs ?? {};
	for (let t of e.seen.entries()) {
		let e = t[1];
		e.def && e.defId && (e.def.id === e.defId && delete e.def.id, o[e.defId] = e.def);
	}
	e.external || Object.keys(o).length > 0 && (e.target === "draft-2020-12" ? i.$defs = o : i.definitions = o);
	try {
		let n = JSON.parse(JSON.stringify(i));
		return Object.defineProperty(n, "~standard", {
			value: {
				...t["~standard"],
				jsonSchema: {
					input: fa(t, "input", e.processors),
					output: fa(t, "output", e.processors)
				}
			},
			enumerable: !1,
			writable: !1
		}), n;
	} catch {
		throw Error("Error converting schema to JSON.");
	}
}
function V(e, t) {
	let n = t ?? { seen: /* @__PURE__ */ new Set() };
	if (n.seen.has(e)) return !1;
	n.seen.add(e);
	let r = e._zod.def;
	if (r.type === "transform") return !0;
	if (r.type === "array") return V(r.element, n);
	if (r.type === "set") return V(r.valueType, n);
	if (r.type === "lazy") return V(r.getter(), n);
	if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault") return V(r.innerType, n);
	if (r.type === "intersection") return V(r.left, n) || V(r.right, n);
	if (r.type === "record" || r.type === "map") return V(r.keyType, n) || V(r.valueType, n);
	if (r.type === "pipe") return e._zod.traits.has("$ZodCodec") ? !0 : V(r.in, n) || V(r.out, n);
	if (r.type === "object") {
		for (let e in r.shape) if (V(r.shape[e], n)) return !0;
		return !1;
	}
	if (r.type === "union") {
		for (let e of r.options) if (V(e, n)) return !0;
		return !1;
	}
	if (r.type === "tuple") {
		for (let e of r.items) if (V(e, n)) return !0;
		return !!(r.rest && V(r.rest, n));
	}
	return !1;
}
var da = (e, t = {}) => (n) => {
	let r = ca({
		...n,
		processors: t
	});
	return B(e, r), la(r, e), ua(r, e);
}, fa = (e, t, n = {}) => (r) => {
	let { libraryOptions: i, target: a } = r ?? {}, o = ca({
		...i ?? {},
		target: a,
		io: t,
		processors: n
	});
	return B(e, o), la(o, e), ua(o, e);
}, pa = {
	guid: "uuid",
	url: "uri",
	datetime: "date-time",
	json_string: "json-string",
	regex: ""
}, ma = (e, t, n, r) => {
	let i = n;
	i.type = "string";
	let { minimum: a, maximum: o, format: s, patterns: c, contentEncoding: l } = e._zod.bag;
	if (typeof a == "number" && (i.minLength = a), typeof o == "number" && (i.maxLength = o), s && (i.format = pa[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), l && (i.contentEncoding = l), c && c.size > 0) {
		let e = [...c];
		e.length === 1 ? i.pattern = e[0].source : e.length > 1 && (i.allOf = [...e.map((e) => ({
			...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
			pattern: e.source
		}))]);
	}
}, ha = (e, t, n, r) => {
	let i = n, { minimum: a, maximum: o, format: s, multipleOf: c, exclusiveMaximum: l, exclusiveMinimum: u } = e._zod.bag;
	typeof s == "string" && s.includes("int") ? i.type = "integer" : i.type = "number";
	let d = typeof u == "number" && u >= (a ?? -Infinity), f = typeof l == "number" && l <= (o ?? Infinity), p = t.target === "draft-04" || t.target === "openapi-3.0";
	d ? p ? (i.minimum = u, i.exclusiveMinimum = !0) : i.exclusiveMinimum = u : typeof a == "number" && (i.minimum = a), f ? p ? (i.maximum = l, i.exclusiveMaximum = !0) : i.exclusiveMaximum = l : typeof o == "number" && (i.maximum = o), typeof c == "number" && (i.multipleOf = c);
}, ga = (e, t, n, r) => {
	n.not = {};
}, _a = (e, t, n, r) => {
	let i = e._zod.def, a = ct(i.entries);
	a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), n.enum = a;
}, va = (e, t, n, r) => {
	let i = e._zod.def, a = [];
	for (let e of i.values) if (e === void 0) {
		if (t.unrepresentable === "throw") throw Error("Literal `undefined` cannot be represented in JSON Schema");
	} else if (typeof e == "bigint") {
		if (t.unrepresentable === "throw") throw Error("BigInt literals cannot be represented in JSON Schema");
		a.push(Number(e));
	} else a.push(e);
	if (a.length !== 0) if (a.length === 1) {
		let e = a[0];
		n.type = e === null ? "null" : typeof e, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [e] : n.const = e;
	} else a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), a.every((e) => typeof e == "boolean") && (n.type = "boolean"), a.every((e) => e === null) && (n.type = "null"), n.enum = a;
}, ya = (e, t, n, r) => {
	if (t.unrepresentable === "throw") throw Error("Custom types cannot be represented in JSON Schema");
}, ba = (e, t, n, r) => {
	if (t.unrepresentable === "throw") throw Error("Transforms cannot be represented in JSON Schema");
}, xa = (e, t, n, r) => {
	let i = n, a = e._zod.def, { minimum: o, maximum: s } = e._zod.bag;
	typeof o == "number" && (i.minItems = o), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = B(a.element, t, {
		...r,
		path: [...r.path, "items"]
	});
}, Sa = (e, t, n, r) => {
	let i = n, a = e._zod.def;
	i.type = "object", i.properties = {};
	let o = a.shape;
	for (let e in o) i.properties[e] = B(o[e], t, {
		...r,
		path: [
			...r.path,
			"properties",
			e
		]
	});
	let s = new Set(Object.keys(o)), c = new Set([...s].filter((e) => {
		let n = a.shape[e]._zod;
		return t.io === "input" ? n.optin === void 0 : n.optout === void 0;
	}));
	c.size > 0 && (i.required = Array.from(c)), a.catchall?._zod.def.type === "never" ? i.additionalProperties = !1 : a.catchall ? a.catchall && (i.additionalProperties = B(a.catchall, t, {
		...r,
		path: [...r.path, "additionalProperties"]
	})) : t.io === "output" && (i.additionalProperties = !1);
}, Ca = (e, t, n, r) => {
	let i = e._zod.def, a = i.inclusive === !1, o = i.options.map((e, n) => B(e, t, {
		...r,
		path: [
			...r.path,
			a ? "oneOf" : "anyOf",
			n
		]
	}));
	a ? n.oneOf = o : n.anyOf = o;
}, wa = (e, t, n, r) => {
	let i = e._zod.def, a = B(i.left, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			0
		]
	}), o = B(i.right, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			1
		]
	}), s = (e) => "allOf" in e && Object.keys(e).length === 1;
	n.allOf = [...s(a) ? a.allOf : [a], ...s(o) ? o.allOf : [o]];
}, Ta = (e, t, n, r) => {
	let i = e._zod.def, a = B(i.innerType, t, r), o = t.seen.get(e);
	t.target === "openapi-3.0" ? (o.ref = i.innerType, n.nullable = !0) : n.anyOf = [a, { type: "null" }];
}, Ea = (e, t, n, r) => {
	let i = e._zod.def;
	B(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, Da = (e, t, n, r) => {
	let i = e._zod.def;
	B(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, Oa = (e, t, n, r) => {
	let i = e._zod.def;
	B(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, ka = (e, t, n, r) => {
	let i = e._zod.def;
	B(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
	let o;
	try {
		o = i.catchValue(void 0);
	} catch {
		throw Error("Dynamic catch values are not supported in JSON Schema");
	}
	n.default = o;
}, Aa = (e, t, n, r) => {
	let i = e._zod.def, a = i.in._zod.traits.has("$ZodTransform"), o = t.io === "input" ? a ? i.out : i.in : i.out;
	B(o, t, r);
	let s = t.seen.get(e);
	s.ref = o;
}, ja = (e, t, n, r) => {
	let i = e._zod.def;
	B(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, n.readOnly = !0;
}, Ma = (e, t, n, r) => {
	let i = e._zod.def;
	B(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, Na = /* @__PURE__ */ C("ZodISODateTime", (e, t) => {
	sr.init(e, t), K.init(e, t);
});
function Pa(e) {
	return /* @__PURE__ */ ji(Na, e);
}
var Fa = /* @__PURE__ */ C("ZodISODate", (e, t) => {
	cr.init(e, t), K.init(e, t);
});
function Ia(e) {
	return /* @__PURE__ */ Mi(Fa, e);
}
var La = /* @__PURE__ */ C("ZodISOTime", (e, t) => {
	lr.init(e, t), K.init(e, t);
});
function Ra(e) {
	return /* @__PURE__ */ Ni(La, e);
}
var za = /* @__PURE__ */ C("ZodISODuration", (e, t) => {
	ur.init(e, t), K.init(e, t);
});
function Ba(e) {
	return /* @__PURE__ */ Pi(za, e);
}
var H = /* @__PURE__ */ C("ZodError", (e, t) => {
	It.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
		format: { value: (t) => zt(e, t) },
		flatten: { value: (t) => Rt(e, t) },
		addIssue: { value: (t) => {
			e.issues.push(t), e.message = JSON.stringify(e.issues, lt, 2);
		} },
		addIssues: { value: (t) => {
			e.issues.push(...t), e.message = JSON.stringify(e.issues, lt, 2);
		} },
		isEmpty: { get() {
			return e.issues.length === 0;
		} }
	});
}, { Parent: Error }), Va = /* @__PURE__ */ Bt(H), Ha = /* @__PURE__ */ Vt(H), Ua = /* @__PURE__ */ Ht(H), Wa = /* @__PURE__ */ Wt(H), Ga = /* @__PURE__ */ Kt(H), Ka = /* @__PURE__ */ qt(H), qa = /* @__PURE__ */ Jt(H), Ja = /* @__PURE__ */ Yt(H), Ya = /* @__PURE__ */ Xt(H), Xa = /* @__PURE__ */ Zt(H), Za = /* @__PURE__ */ Qt(H), Qa = /* @__PURE__ */ $t(H), $a = /* @__PURE__ */ new WeakMap();
function U(e, t, n) {
	let r = Object.getPrototypeOf(e), i = $a.get(r);
	if (i || (i = /* @__PURE__ */ new Set(), $a.set(r, i)), !i.has(t)) {
		i.add(t);
		for (let e in n) {
			let t = n[e];
			Object.defineProperty(r, e, {
				configurable: !0,
				enumerable: !1,
				get() {
					let n = t.bind(this);
					return Object.defineProperty(this, e, {
						configurable: !0,
						writable: !0,
						enumerable: !0,
						value: n
					}), n;
				},
				set(t) {
					Object.defineProperty(this, e, {
						configurable: !0,
						writable: !0,
						enumerable: !0,
						value: t
					});
				}
			});
		}
	}
}
var W = /* @__PURE__ */ C("ZodType", (e, t) => (L.init(e, t), Object.assign(e["~standard"], { jsonSchema: {
	input: fa(e, "input"),
	output: fa(e, "output")
} }), e.toJSONSchema = da(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.parse = (t, n) => Va(e, t, n, { callee: e.parse }), e.safeParse = (t, n) => Ua(e, t, n), e.parseAsync = async (t, n) => Ha(e, t, n, { callee: e.parseAsync }), e.safeParseAsync = async (t, n) => Wa(e, t, n), e.spa = e.safeParseAsync, e.encode = (t, n) => Ga(e, t, n), e.decode = (t, n) => Ka(e, t, n), e.encodeAsync = async (t, n) => qa(e, t, n), e.decodeAsync = async (t, n) => Ja(e, t, n), e.safeEncode = (t, n) => Ya(e, t, n), e.safeDecode = (t, n) => Xa(e, t, n), e.safeEncodeAsync = async (t, n) => Za(e, t, n), e.safeDecodeAsync = async (t, n) => Qa(e, t, n), U(e, "ZodType", {
	check(...e) {
		let t = this.def;
		return this.clone(O(t, { checks: [...t.checks ?? [], ...e.map((e) => typeof e == "function" ? { _zod: {
			check: e,
			def: { check: "custom" },
			onattach: []
		} } : e)] }), { parent: !0 });
	},
	with(...e) {
		return this.check(...e);
	},
	clone(e, t) {
		return j(this, e, t);
	},
	brand() {
		return this;
	},
	register(e, t) {
		return e.add(this, t), this;
	},
	refine(e, t) {
		return this.check(os(e, t));
	},
	superRefine(e, t) {
		return this.check(ss(e, t));
	},
	overwrite(e) {
		return this.check(/* @__PURE__ */ z(e));
	},
	optional() {
		return Ho(this);
	},
	exactOptional() {
		return Wo(this);
	},
	nullable() {
		return Ko(this);
	},
	nullish() {
		return Ho(Ko(this));
	},
	nonoptional(e) {
		return Qo(this, e);
	},
	array() {
		return J(this);
	},
	or(e) {
		return X([this, e]);
	},
	and(e) {
		return Fo(this, e);
	},
	transform(e) {
		return ns(this, Bo(e));
	},
	default(e) {
		return Jo(this, e);
	},
	prefault(e) {
		return Xo(this, e);
	},
	catch(e) {
		return es(this, e);
	},
	pipe(e) {
		return ns(this, e);
	},
	readonly() {
		return is(this);
	},
	describe(e) {
		let t = this.clone();
		return si.add(t, { description: e }), t;
	},
	meta(...e) {
		if (e.length === 0) return si.get(this);
		let t = this.clone();
		return si.add(t, e[0]), t;
	},
	isOptional() {
		return this.safeParse(void 0).success;
	},
	isNullable() {
		return this.safeParse(null).success;
	},
	apply(e) {
		return e(this);
	}
}), Object.defineProperty(e, "description", {
	get() {
		return si.get(e)?.description;
	},
	configurable: !0
}), e)), eo = /* @__PURE__ */ C("_ZodString", (e, t) => {
	Yn.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => ma(e, t, n, r);
	let n = e._zod.bag;
	e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, U(e, "_ZodString", {
		regex(...e) {
			return this.check(/* @__PURE__ */ qi(...e));
		},
		includes(...e) {
			return this.check(/* @__PURE__ */ Xi(...e));
		},
		startsWith(...e) {
			return this.check(/* @__PURE__ */ Zi(...e));
		},
		endsWith(...e) {
			return this.check(/* @__PURE__ */ Qi(...e));
		},
		min(...e) {
			return this.check(/* @__PURE__ */ Gi(...e));
		},
		max(...e) {
			return this.check(/* @__PURE__ */ Wi(...e));
		},
		length(...e) {
			return this.check(/* @__PURE__ */ Ki(...e));
		},
		nonempty(...e) {
			return this.check(/* @__PURE__ */ Gi(1, ...e));
		},
		lowercase(e) {
			return this.check(/* @__PURE__ */ Ji(e));
		},
		uppercase(e) {
			return this.check(/* @__PURE__ */ Yi(e));
		},
		trim() {
			return this.check(/* @__PURE__ */ ea());
		},
		normalize(...e) {
			return this.check(/* @__PURE__ */ $i(...e));
		},
		toLowerCase() {
			return this.check(/* @__PURE__ */ ta());
		},
		toUpperCase() {
			return this.check(/* @__PURE__ */ na());
		},
		slugify() {
			return this.check(/* @__PURE__ */ ra());
		}
	});
}), to = /* @__PURE__ */ C("ZodString", (e, t) => {
	Yn.init(e, t), eo.init(e, t), e.email = (t) => e.check(/* @__PURE__ */ li(no, t)), e.url = (t) => e.check(/* @__PURE__ */ hi(ao, t)), e.jwt = (t) => e.check(/* @__PURE__ */ Ai(xo, t)), e.emoji = (t) => e.check(/* @__PURE__ */ gi(oo, t)), e.guid = (t) => e.check(/* @__PURE__ */ ui(ro, t)), e.uuid = (t) => e.check(/* @__PURE__ */ di(io, t)), e.uuidv4 = (t) => e.check(/* @__PURE__ */ fi(io, t)), e.uuidv6 = (t) => e.check(/* @__PURE__ */ pi(io, t)), e.uuidv7 = (t) => e.check(/* @__PURE__ */ mi(io, t)), e.nanoid = (t) => e.check(/* @__PURE__ */ _i(so, t)), e.guid = (t) => e.check(/* @__PURE__ */ ui(ro, t)), e.cuid = (t) => e.check(/* @__PURE__ */ vi(co, t)), e.cuid2 = (t) => e.check(/* @__PURE__ */ yi(lo, t)), e.ulid = (t) => e.check(/* @__PURE__ */ bi(uo, t)), e.base64 = (t) => e.check(/* @__PURE__ */ Di(vo, t)), e.base64url = (t) => e.check(/* @__PURE__ */ Oi(yo, t)), e.xid = (t) => e.check(/* @__PURE__ */ xi(fo, t)), e.ksuid = (t) => e.check(/* @__PURE__ */ Si(po, t)), e.ipv4 = (t) => e.check(/* @__PURE__ */ Ci(mo, t)), e.ipv6 = (t) => e.check(/* @__PURE__ */ wi(ho, t)), e.cidrv4 = (t) => e.check(/* @__PURE__ */ Ti(go, t)), e.cidrv6 = (t) => e.check(/* @__PURE__ */ Ei(_o, t)), e.e164 = (t) => e.check(/* @__PURE__ */ ki(bo, t)), e.datetime = (t) => e.check(Pa(t)), e.date = (t) => e.check(Ia(t)), e.time = (t) => e.check(Ra(t)), e.duration = (t) => e.check(Ba(t));
});
function G(e) {
	return /* @__PURE__ */ ci(to, e);
}
var K = /* @__PURE__ */ C("ZodStringFormat", (e, t) => {
	R.init(e, t), eo.init(e, t);
}), no = /* @__PURE__ */ C("ZodEmail", (e, t) => {
	Qn.init(e, t), K.init(e, t);
}), ro = /* @__PURE__ */ C("ZodGUID", (e, t) => {
	Xn.init(e, t), K.init(e, t);
}), io = /* @__PURE__ */ C("ZodUUID", (e, t) => {
	Zn.init(e, t), K.init(e, t);
}), ao = /* @__PURE__ */ C("ZodURL", (e, t) => {
	$n.init(e, t), K.init(e, t);
}), oo = /* @__PURE__ */ C("ZodEmoji", (e, t) => {
	er.init(e, t), K.init(e, t);
}), so = /* @__PURE__ */ C("ZodNanoID", (e, t) => {
	tr.init(e, t), K.init(e, t);
}), co = /* @__PURE__ */ C("ZodCUID", (e, t) => {
	nr.init(e, t), K.init(e, t);
}), lo = /* @__PURE__ */ C("ZodCUID2", (e, t) => {
	rr.init(e, t), K.init(e, t);
}), uo = /* @__PURE__ */ C("ZodULID", (e, t) => {
	ir.init(e, t), K.init(e, t);
}), fo = /* @__PURE__ */ C("ZodXID", (e, t) => {
	ar.init(e, t), K.init(e, t);
}), po = /* @__PURE__ */ C("ZodKSUID", (e, t) => {
	or.init(e, t), K.init(e, t);
}), mo = /* @__PURE__ */ C("ZodIPv4", (e, t) => {
	dr.init(e, t), K.init(e, t);
}), ho = /* @__PURE__ */ C("ZodIPv6", (e, t) => {
	fr.init(e, t), K.init(e, t);
}), go = /* @__PURE__ */ C("ZodCIDRv4", (e, t) => {
	pr.init(e, t), K.init(e, t);
}), _o = /* @__PURE__ */ C("ZodCIDRv6", (e, t) => {
	mr.init(e, t), K.init(e, t);
}), vo = /* @__PURE__ */ C("ZodBase64", (e, t) => {
	gr.init(e, t), K.init(e, t);
}), yo = /* @__PURE__ */ C("ZodBase64URL", (e, t) => {
	vr.init(e, t), K.init(e, t);
}), bo = /* @__PURE__ */ C("ZodE164", (e, t) => {
	yr.init(e, t), K.init(e, t);
}), xo = /* @__PURE__ */ C("ZodJWT", (e, t) => {
	xr.init(e, t), K.init(e, t);
}), So = /* @__PURE__ */ C("ZodNumber", (e, t) => {
	Sr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => ha(e, t, n, r), U(e, "ZodNumber", {
		gt(e, t) {
			return this.check(/* @__PURE__ */ Vi(e, t));
		},
		gte(e, t) {
			return this.check(/* @__PURE__ */ Hi(e, t));
		},
		min(e, t) {
			return this.check(/* @__PURE__ */ Hi(e, t));
		},
		lt(e, t) {
			return this.check(/* @__PURE__ */ zi(e, t));
		},
		lte(e, t) {
			return this.check(/* @__PURE__ */ Bi(e, t));
		},
		max(e, t) {
			return this.check(/* @__PURE__ */ Bi(e, t));
		},
		int(e) {
			return this.check(wo(e));
		},
		safe(e) {
			return this.check(wo(e));
		},
		positive(e) {
			return this.check(/* @__PURE__ */ Vi(0, e));
		},
		nonnegative(e) {
			return this.check(/* @__PURE__ */ Hi(0, e));
		},
		negative(e) {
			return this.check(/* @__PURE__ */ zi(0, e));
		},
		nonpositive(e) {
			return this.check(/* @__PURE__ */ Bi(0, e));
		},
		multipleOf(e, t) {
			return this.check(/* @__PURE__ */ Ui(e, t));
		},
		step(e, t) {
			return this.check(/* @__PURE__ */ Ui(e, t));
		},
		finite() {
			return this;
		}
	});
	let n = e._zod.bag;
	e.minValue = Math.max(n.minimum ?? -Infinity, n.exclusiveMinimum ?? -Infinity) ?? null, e.maxValue = Math.min(n.maximum ?? Infinity, n.exclusiveMaximum ?? Infinity) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? .5), e.isFinite = !0, e.format = n.format ?? null;
});
function q(e) {
	return /* @__PURE__ */ Fi(So, e);
}
var Co = /* @__PURE__ */ C("ZodNumberFormat", (e, t) => {
	Cr.init(e, t), So.init(e, t);
});
function wo(e) {
	return /* @__PURE__ */ Ii(Co, e);
}
var To = /* @__PURE__ */ C("ZodUnknown", (e, t) => {
	wr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (e, t, n) => void 0;
});
function Eo() {
	return /* @__PURE__ */ Li(To);
}
var Do = /* @__PURE__ */ C("ZodNever", (e, t) => {
	Tr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => ga(e, t, n, r);
});
function Oo(e) {
	return /* @__PURE__ */ Ri(Do, e);
}
var ko = /* @__PURE__ */ C("ZodArray", (e, t) => {
	Dr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => xa(e, t, n, r), e.element = t.element, U(e, "ZodArray", {
		min(e, t) {
			return this.check(/* @__PURE__ */ Gi(e, t));
		},
		nonempty(e) {
			return this.check(/* @__PURE__ */ Gi(1, e));
		},
		max(e, t) {
			return this.check(/* @__PURE__ */ Wi(e, t));
		},
		length(e, t) {
			return this.check(/* @__PURE__ */ Ki(e, t));
		},
		unwrap() {
			return this.element;
		}
	});
});
function J(e, t) {
	return /* @__PURE__ */ ia(ko, e, t);
}
var Ao = /* @__PURE__ */ C("ZodObject", (e, t) => {
	Mr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => Sa(e, t, n, r), E(e, "shape", () => t.shape), U(e, "ZodObject", {
		keyof() {
			return Lo(Object.keys(this._zod.def.shape));
		},
		catchall(e) {
			return this.clone({
				...this._zod.def,
				catchall: e
			});
		},
		passthrough() {
			return this.clone({
				...this._zod.def,
				catchall: Eo()
			});
		},
		loose() {
			return this.clone({
				...this._zod.def,
				catchall: Eo()
			});
		},
		strict() {
			return this.clone({
				...this._zod.def,
				catchall: Oo()
			});
		},
		strip() {
			return this.clone({
				...this._zod.def,
				catchall: void 0
			});
		},
		extend(e) {
			return Et(this, e);
		},
		safeExtend(e) {
			return Dt(this, e);
		},
		merge(e) {
			return Ot(this, e);
		},
		pick(e) {
			return wt(this, e);
		},
		omit(e) {
			return Tt(this, e);
		},
		partial(...e) {
			return kt(Vo, this, e[0]);
		},
		required(...e) {
			return At(Zo, this, e[0]);
		}
	});
});
function Y(e, t) {
	return new Ao({
		type: "object",
		shape: e ?? {},
		...M(t)
	});
}
var jo = /* @__PURE__ */ C("ZodUnion", (e, t) => {
	Pr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ca(e, t, n, r), e.options = t.options;
});
function X(e, t) {
	return new jo({
		type: "union",
		options: e,
		...M(t)
	});
}
var Mo = /* @__PURE__ */ C("ZodDiscriminatedUnion", (e, t) => {
	jo.init(e, t), Fr.init(e, t);
});
function No(e, t, n) {
	return new Mo({
		type: "union",
		options: t,
		discriminator: e,
		...M(n)
	});
}
var Po = /* @__PURE__ */ C("ZodIntersection", (e, t) => {
	Ir.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => wa(e, t, n, r);
});
function Fo(e, t) {
	return new Po({
		type: "intersection",
		left: e,
		right: t
	});
}
var Io = /* @__PURE__ */ C("ZodEnum", (e, t) => {
	zr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => _a(e, t, n, r), e.enum = t.entries, e.options = Object.values(t.entries);
	let n = new Set(Object.keys(t.entries));
	e.extract = (e, r) => {
		let i = {};
		for (let r of e) if (n.has(r)) i[r] = t.entries[r];
		else throw Error(`Key ${r} not found in enum`);
		return new Io({
			...t,
			checks: [],
			...M(r),
			entries: i
		});
	}, e.exclude = (e, r) => {
		let i = { ...t.entries };
		for (let t of e) if (n.has(t)) delete i[t];
		else throw Error(`Key ${t} not found in enum`);
		return new Io({
			...t,
			checks: [],
			...M(r),
			entries: i
		});
	};
});
function Lo(e, t) {
	return new Io({
		type: "enum",
		entries: Array.isArray(e) ? Object.fromEntries(e.map((e) => [e, e])) : e,
		...M(t)
	});
}
var Ro = /* @__PURE__ */ C("ZodLiteral", (e, t) => {
	Br.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => va(e, t, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", { get() {
		if (t.values.length > 1) throw Error("This schema contains multiple valid literal values. Use `.values` instead.");
		return t.values[0];
	} });
});
function Z(e, t) {
	return new Ro({
		type: "literal",
		values: Array.isArray(e) ? e : [e],
		...M(t)
	});
}
var zo = /* @__PURE__ */ C("ZodTransform", (e, t) => {
	Vr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => ba(e, t, n, r), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new ot(e.constructor.name);
		n.addIssue = (r) => {
			if (typeof r == "string") n.issues.push(F(r, n.value, t));
			else {
				let t = r;
				t.fatal && (t.continue = !1), t.code ??= "custom", t.input ??= n.value, t.inst ??= e, n.issues.push(F(t));
			}
		};
		let i = t.transform(n.value, n);
		return i instanceof Promise ? i.then((e) => (n.value = e, n.fallback = !0, n)) : (n.value = i, n.fallback = !0, n);
	};
});
function Bo(e) {
	return new zo({
		type: "transform",
		transform: e
	});
}
var Vo = /* @__PURE__ */ C("ZodOptional", (e, t) => {
	Ur.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ma(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Ho(e) {
	return new Vo({
		type: "optional",
		innerType: e
	});
}
var Uo = /* @__PURE__ */ C("ZodExactOptional", (e, t) => {
	Wr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ma(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Wo(e) {
	return new Uo({
		type: "optional",
		innerType: e
	});
}
var Go = /* @__PURE__ */ C("ZodNullable", (e, t) => {
	Gr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ta(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Ko(e) {
	return new Go({
		type: "nullable",
		innerType: e
	});
}
var qo = /* @__PURE__ */ C("ZodDefault", (e, t) => {
	Kr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => Da(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Jo(e, t) {
	return new qo({
		type: "default",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : bt(t);
		}
	});
}
var Yo = /* @__PURE__ */ C("ZodPrefault", (e, t) => {
	Jr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => Oa(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Xo(e, t) {
	return new Yo({
		type: "prefault",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : bt(t);
		}
	});
}
var Zo = /* @__PURE__ */ C("ZodNonOptional", (e, t) => {
	Yr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ea(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Qo(e, t) {
	return new Zo({
		type: "nonoptional",
		innerType: e,
		...M(t)
	});
}
var $o = /* @__PURE__ */ C("ZodCatch", (e, t) => {
	Zr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => ka(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function es(e, t) {
	return new $o({
		type: "catch",
		innerType: e,
		catchValue: typeof t == "function" ? t : () => t
	});
}
var ts = /* @__PURE__ */ C("ZodPipe", (e, t) => {
	Qr.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => Aa(e, t, n, r), e.in = t.in, e.out = t.out;
});
function ns(e, t) {
	return new ts({
		type: "pipe",
		in: e,
		out: t
	});
}
var rs = /* @__PURE__ */ C("ZodReadonly", (e, t) => {
	ei.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => ja(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function is(e) {
	return new rs({
		type: "readonly",
		innerType: e
	});
}
var as = /* @__PURE__ */ C("ZodCustom", (e, t) => {
	ni.init(e, t), W.init(e, t), e._zod.processJSONSchema = (t, n, r) => ya(e, t, n, r);
});
function os(e, t = {}) {
	return /* @__PURE__ */ aa(as, e, t);
}
function ss(e, t) {
	return /* @__PURE__ */ oa(e, t);
}
//#endregion
//#region src/here-attributes.ts
var cs = Y({
	tileId: q(),
	level: q(),
	mapRegion: G(),
	mapRelease: G()
}), ls = X([
	Z("SPEED_LIMITS_FC1"),
	Z("SPEED_LIMITS_FC2"),
	Z("SPEED_LIMITS_FC3"),
	Z("SPEED_LIMITS_FC4"),
	Z("SPEED_LIMITS_FC5")
]), us = X([
	Z("SPEED_LIMITS_COND_FC1"),
	Z("SPEED_LIMITS_COND_FC2"),
	Z("SPEED_LIMITS_COND_FC3"),
	Z("SPEED_LIMITS_COND_FC4"),
	Z("SPEED_LIMITS_COND_FC5")
]), ds = X([
	Z("SPEED_LIMITS_VAR_FC1"),
	Z("SPEED_LIMITS_VAR_FC2"),
	Z("SPEED_LIMITS_VAR_FC3"),
	Z("SPEED_LIMITS_VAR_FC4"),
	Z("SPEED_LIMITS_VAR_FC5")
]), fs = X([
	Z("ROAD_GEOM_FC1"),
	Z("ROAD_GEOM_FC2"),
	Z("ROAD_GEOM_FC3"),
	Z("ROAD_GEOM_FC4"),
	Z("ROAD_GEOM_FC5")
]), ps = cs.extend({ layerName: ls }), ms = cs.extend({ layerName: us }), hs = cs.extend({ layerName: ds }), gs = cs.extend({ layerName: fs }), _s = Y({
	LINK_ID: G(),
	FROM_REF_SPEED_LIMIT: G().nullable(),
	TO_REF_SPEED_LIMIT: G().nullable(),
	SPEED_LIMIT_SOURCE: G(),
	SPEED_LIMIT_UNIT: G(),
	TOPOLOGY_ID: G(),
	START_OFFSET: G(),
	END_OFFSET: G()
}), vs = Y({
	CONDITION_ID: G(),
	LINK_ID: G(),
	SPEED_LIMIT_TYPE: G(),
	SPEED_LIMIT: G(),
	DEPENDEND_SPEED_TYPE: G().nullable(),
	TIME_OVERRIDE: G().nullable(),
	VEHICLE_TYPES: G().nullable(),
	DATE_TIMES: G().nullable(),
	TOPOLOGY_ID: G(),
	START_OFFSET: G(),
	END_OFFSET: G()
}), ys = Y({}).passthrough(), bs = Y({
	LINK_ID: G(),
	LONG_HAUL: G().nullable(),
	NAME: G().nullable(),
	NAMES: G().nullable(),
	TUNNEL: G().nullable(),
	BRIDGE: G().nullable(),
	LAT: G(),
	LON: G(),
	ZLEVEL: G(),
	ELEVATION: G().nullable(),
	TOPOLOGY_ID: G(),
	START_OFFSET: G(),
	END_OFFSET: G()
}), xs = Y({
	Meta: ps,
	Rows: J(_s)
}), Ss = Y({
	Meta: ms,
	Rows: J(vs)
}), Cs = Y({
	Meta: hs,
	Rows: J(ys)
}), ws = Y({
	Meta: gs,
	Rows: J(bs)
}), Ts = {
	ROAD_GEOM: ws,
	SPEED_LIMITS: xs,
	SPEED_LIMITS_COND: Ss,
	SPEED_LIMITS_VAR: Cs
}, Es = /^(ROAD_GEOM|SPEED_LIMITS|SPEED_LIMITS_COND|SPEED_LIMITS_VAR)_FC[1-5]$/;
function Ds(e) {
	let t = typeof e == "object" && e && "Meta" in e ? e.Meta?.layerName : void 0, n = typeof t == "string" ? Es.exec(t)?.[1] : void 0;
	return n ? Ts[n] : void 0;
}
var Os = Eo().transform((e, t) => {
	let n = Ds(e);
	if (!n) return t.addIssue({
		code: "custom",
		message: "Unsupported HERE tile layer",
		input: e
	}), at;
	let r = n.safeParse(e);
	return r.success ? r.data : (r.error.issues.forEach((n) => t.addIssue({
		code: "custom",
		message: n.message,
		path: n.path,
		input: e
	})), at);
}), ks = Y({ Tiles: J(Os) });
function As(e) {
	return fs.safeParse(e.Meta.layerName).success;
}
function js(e) {
	return ls.safeParse(e.Meta.layerName).success;
}
var Ms = {
	1: 9,
	2: 10,
	3: 11,
	4: 12,
	5: 13
}, Ns = [
	1,
	2,
	3,
	4,
	5
], Ps = 25;
function Fs(e, t, n) {
	return Math.min(Math.max(e, t), n);
}
function Is(e) {
	return {
		west: Math.min(e.west, e.east),
		east: Math.max(e.west, e.east),
		south: Math.min(e.south, e.north),
		north: Math.max(e.south, e.north)
	};
}
function Ls(e, t = 5, n = 25, r = Ns) {
	let i = Is(e), a = (e) => {
		let t = Ms[e], n = 180 / 2 ** t, r = 2 ** (t + 1), a = Fs(Math.trunc((i.west + 180) / n), 0, r - 1), o = Fs(Math.trunc((i.east + 180) / n), 0, r - 1), s = Fs(Math.trunc((i.south + 90) / n), 0, r - 1), c = Fs(Math.trunc((i.north + 90) / n), 0, r - 1), l = o - a + 1, u = c - s + 1;
		return Array.from({ length: l * u }, (n, i) => {
			let o = s + Math.floor(i / l), c = a + i % l;
			return {
				tileId: String(o * r + c),
				fcLevel: e,
				apiLevel: t
			};
		});
	};
	return r.filter((e) => e <= t).reduce((e, t) => e.length >= n ? e : e.concat(a(t).slice(0, n - e.length)), []);
}
function Rs(e) {
	return `${e.apiLevel}:${e.tileId}`;
}
//#endregion
//#region src/here-cache-gateway.ts
var zs = 1, Bs = 2e4, Vs = 5e3, Hs = 3 * Vs, Us = 15e3, Ws = 30, Gs = 16 * 1024 * 1024, Ks = 64 * 1024 * 1024, qs = Gs + 64 * 1024, Js = "application/x-ndjson", Ys = [
	100,
	200,
	400,
	800,
	1500,
	2e3,
	2e3,
	2e3,
	2e3,
	2e3,
	2e3
], Xs = 25e3, Zs = X([
	Z(9),
	Z(10),
	Z(11),
	Z(12),
	Z(13)
]), Qs = G().regex(/^(0|[1-9]\d*)$/).refine((e) => Number.isSafeInteger(Number(e)), { message: "tileId must be a non-negative safe integer" }), Q = Y({
	apiLevel: Zs,
	tileId: Qs
}).strict(), $s = Q, ec = Q.extend({
	fetchedAt: G().datetime({ offset: !0 }),
	data: ks
}).strict(), tc = G().uuid(), $ = q().int().positive().safe(), nc = Q.extend({ owner: tc }).strict(), rc = nc.extend({ generation: $ }).strict(), ic = rc, ac = Y({
	schemaVersion: Z(1),
	tile: Q,
	fetchedAt: G().datetime({ offset: !0 }),
	sha256: G().regex(/^[a-f0-9]{64}$/),
	data: ks
}).strict(), oc = No("status", [Y({
	operation: Z("read"),
	status: Z("hit"),
	tile: Q,
	etag: G(),
	envelope: ac
}).strict(), Y({
	operation: Z("read"),
	status: Lo([
		"miss",
		"stale",
		"corrupt",
		"error"
	]),
	tile: Q
}).strict()]), sc = No("status", [Y({
	operation: Z("write"),
	status: Z("written"),
	tile: Q,
	etag: G(),
	fetchedAt: G().datetime({ offset: !0 }),
	sha256: G().regex(/^[a-f0-9]{64}$/)
}).strict(), Y({
	operation: Z("write"),
	status: Lo([
		"not_modified",
		"conflict",
		"error"
	]),
	tile: Q
}).strict()]), cc = No("status", [
	Y({
		operation: Z("lease_acquire"),
		status: Z("acquired"),
		tile: Q,
		owner: tc,
		generation: $,
		expiresAt: q().int().positive().safe(),
		renewAfterMs: Z(Vs)
	}).strict(),
	Y({
		operation: Z("lease_acquire"),
		status: Z("filled"),
		tile: Q,
		etag: G(),
		envelope: ac
	}).strict(),
	Y({
		operation: Z("lease_acquire"),
		status: Z("contended"),
		tile: Q,
		generation: $,
		expiresAt: q().int().positive().safe()
	}).strict(),
	Y({
		operation: Z("lease_acquire"),
		status: Z("error"),
		tile: Q
	}).strict()
]), lc = No("status", [
	Y({
		operation: Z("lease_renew"),
		status: Z("renewed"),
		tile: Q,
		owner: tc,
		generation: $,
		expiresAt: q().int().positive().safe(),
		renewAfterMs: Z(Vs)
	}).strict(),
	Y({
		operation: Z("lease_renew"),
		status: Z("lost"),
		tile: Q
	}).strict(),
	Y({
		operation: Z("lease_renew"),
		status: Z("error"),
		tile: Q
	}).strict()
]), uc = No("status", [
	Y({
		operation: Z("lease_release"),
		status: Z("released"),
		tile: Q,
		generation: $
	}).strict(),
	Y({
		operation: Z("lease_release"),
		status: Z("lost"),
		tile: Q
	}).strict(),
	Y({
		operation: Z("lease_release"),
		status: Z("error"),
		tile: Q
	}).strict()
]), dc = Y({
	operation: Z("error"),
	status: Z("error"),
	code: G(),
	line: q().int().positive().optional()
}).strict(), fc = new TextEncoder();
function pc(e, t) {
	if (Array.isArray(e)) {
		e.forEach((e) => pc(e, t));
		return;
	}
	!e || typeof e != "object" || Object.entries(e).forEach(([e, n]) => {
		t.add(e), pc(n, t);
	});
}
function mc(e) {
	let t = /* @__PURE__ */ new Set();
	return pc(e, t), JSON.stringify(e, [...t].sort());
}
function hc(e) {
	return fc.encode(e).byteLength;
}
async function gc(e) {
	return [...new Uint8Array(await crypto.subtle.digest("SHA-256", fc.encode(e)))].map((e) => e.toString(16).padStart(2, "0")).join("");
}
//#endregion
//#region src/map-shared.ts
var _c = "1.0.4.0", vc = _c, yc = 512, bc = "road-overlays", xc = 85.05112878, Sc = "#22ff22", Cc = "#ff0000", wc = 35, Tc = 25;
function Ec(e, t) {
	if (e === null) return null;
	let n = typeof e == "string" ? parseFloat(e) : e;
	return Number.isFinite(n) ? t?.trim().toUpperCase() === "MPH" ? Math.round(n) : Math.round(n / 1.60934) : null;
}
function Dc(...e) {
	return e.find((e) => e != null && e !== "") ?? null;
}
function Oc({ max: e, min: t, name: n, value: r }) {
	if (!Number.isInteger(r) || r < t || r > e) throw Error(`${n} must be an integer between ${t} and ${e}`);
}
function kc(e) {
	return Oc({
		name: "z",
		value: e,
		min: 0,
		max: 30
	}), 2 ** e;
}
function Ac(e) {
	return Math.min(Math.max(e, -xc), xc);
}
function jc({ x: e, y: t, z: n }) {
	let r = kc(n);
	return Oc({
		name: "x",
		value: e,
		min: 0,
		max: r - 1
	}), Oc({
		name: "y",
		value: t,
		min: 0,
		max: r - 1
	}), {
		x: e,
		y: t,
		z: n
	};
}
function Mc(e) {
	let { x: t, y: n, z: r } = jc(e);
	return `${bc}/${_c}/${r}/${t}/${n}/tile.${e.fmt}`;
}
function Nc(e) {
	let t = Mc(e);
	return e.baseUrl ? `${e.baseUrl.replace(/\/+$/, "")}/${t}` : `/${t}`;
}
function Pc(e) {
	let t = Ac(e.lat) * Math.PI / 180, n = kc(e.z);
	return {
		x: n * ((e.lng + 180) / 360),
		y: n * (1 - Math.log(Math.tan(t) + 1 / Math.cos(t)) / Math.PI) / 2
	};
}
function Fc({ lat: e, lng: t, tileSize: n = 512, z: r }) {
	let i = Pc({
		lat: e,
		lng: t,
		z: r
	});
	return {
		x: i.x * n,
		y: i.y * n
	};
}
function Ic({ lat: e, lng: t, tileSize: n = 512, x: r, y: i, z: a }) {
	let o = Fc({
		lat: e,
		lng: t,
		tileSize: n,
		z: a
	});
	return {
		x: o.x - r * n,
		y: o.y - i * n
	};
}
function Lc(e, t) {
	let n = Math.PI - 2 * Math.PI * e / kc(t);
	return Math.atan(Math.sinh(n)) * 180 / Math.PI;
}
function Rc(e) {
	let { x: t, y: n, z: r } = jc(e), i = kc(r);
	return {
		west: t / i * 360 - 180,
		east: (t + 1) / i * 360 - 180,
		north: Lc(n, r),
		south: Lc(n + 1, r)
	};
}
function zc(e, t) {
	let n = (e.east - e.west) * t, r = (e.north - e.south) * t;
	return {
		west: Math.max(-180, e.west - n),
		east: Math.min(180, e.east + n),
		north: Ac(e.north + r),
		south: Ac(e.south - r)
	};
}
//#endregion
//#region src/metrics/emf.ts
var Bc = "Chip/Map";
function Vc(e, t, n) {
	if (e.length !== 0) try {
		let r = Object.entries(t ?? {}), i = { _aws: {
			Timestamp: Date.now(),
			CloudWatchMetrics: [{
				Namespace: Bc,
				Dimensions: r.length > 0 ? [r.map(([e]) => e)] : [[]],
				Metrics: e.map((e) => ({
					Name: e.name,
					Unit: e.unit ?? "None"
				}))
			}]
		} };
		for (let [e, t] of r) i[e] = t;
		for (let t of e) i[t.name] = t.value;
		for (let [e, t] of Object.entries(n ?? {})) t !== void 0 && (i[e] = t);
		console.log(JSON.stringify(i));
	} catch (e) {
		console.error("[metrics] failed to emit EMF", e);
	}
}
function Hc() {
	let e = performance.now();
	return () => performance.now() - e;
}
//#endregion
//#region src/metrics/here.ts
async function Uc(e, t) {
	let n = Hc(), r = {
		Service: e.service,
		Env: process.env.NODE_ENV ?? "local"
	}, i = {
		endpoint: e.endpoint,
		resolver: e.resolver ?? "unknown",
		...e.properties
	};
	try {
		let a = await t(), o = [
			{
				name: "HereApiRequests",
				value: 1,
				unit: "Count"
			},
			{
				name: "HereApiErrors",
				value: 0,
				unit: "Count"
			},
			{
				name: "HereApiLatencyMs",
				value: n(),
				unit: "Milliseconds"
			}
		];
		return e.tileLayerRefs !== void 0 && o.push({
			name: "HereApiTileLayerRefs",
			value: e.tileLayerRefs,
			unit: "Count"
		}), Vc(o, r, {
			...i,
			status: "ok"
		}), a;
	} catch (e) {
		throw Vc([
			{
				name: "HereApiRequests",
				value: 1,
				unit: "Count"
			},
			{
				name: "HereApiErrors",
				value: 1,
				unit: "Count"
			},
			{
				name: "HereApiLatencyMs",
				value: n(),
				unit: "Milliseconds"
			}
		], r, {
			...i,
			status: "error"
		}), e;
	}
}
//#endregion
//#region src/promise-helpers.ts
async function Wc(e) {
	return new Promise((t) => setTimeout(t, e));
}
//#endregion
//#region src/uuid-helpers.ts
function Gc(e) {
	let t = e.toString(16).padStart(32, "0");
	return [
		t.slice(0, 8),
		t.slice(8, 12),
		t.slice(12, 16),
		t.slice(16, 20),
		t.slice(20, 32)
	].join("-");
}
//#endregion
//#region src/index.ts
function Kc(e) {
	return e != null;
}
function qc(e) {
	return e ? e.filter(Kc) : [];
}
function Jc(e) {
	return e?.filter?.(Kc) ?? [];
}
function Yc(e) {
	return e ? Object.fromEntries(Jc(e)) : {};
}
function Xc(e) {
	return e ? Jc(e).reduce((e, [t, n]) => (e[t] || (e[t] = []), e[t].push(n), e), {}) : {};
}
//#endregion
export { u as API_ERRORS, Ps as DEFAULT_MAX_TILES, Ms as FC_LEVEL, Ns as FC_ORDER, Us as HERE_CACHE_FOLLOWER_MAX_WAIT_MS, Ys as HERE_CACHE_FOLLOWER_POLL_BACKOFF_MS, Xs as HERE_CACHE_LEASE_ACQUIRE_DEADLINE_MS, Bs as HERE_CACHE_LEASE_DURATION_MS, Hs as HERE_CACHE_LEASE_HANDOVER_MIN_LIFETIME_MS, Vs as HERE_CACHE_LEASE_RENEW_INTERVAL_MS, Ws as HERE_CACHE_MAX_BATCH_TILES, qs as HERE_CACHE_MAX_NDJSON_LINE_BYTES, Ks as HERE_CACHE_MAX_REQUEST_BYTES, Gs as HERE_CACHE_MAX_TILE_PAYLOAD_BYTES, Js as HERE_CACHE_NDJSON_CONTENT_TYPE, zs as HERE_CACHE_SCHEMA_VERSION, ks as HereAttributesResponseSchema, Zs as HereCacheApiLevelSchema, nc as HereCacheLeaseAcquireRequestSchema, cc as HereCacheLeaseAcquireResponseSchema, $ as HereCacheLeaseGenerationSchema, tc as HereCacheLeaseOwnerSchema, ic as HereCacheLeaseReleaseRequestSchema, uc as HereCacheLeaseReleaseResponseSchema, rc as HereCacheLeaseRenewRequestSchema, lc as HereCacheLeaseRenewResponseSchema, ac as HereCacheObjectEnvelopeSchema, $s as HereCacheReadRequestSchema, oc as HereCacheReadResponseSchema, dc as HereCacheStreamErrorSchema, Qs as HereCacheTileIdSchema, Q as HereCacheTileReferenceSchema, ec as HereCacheWriteRequestSchema, sc as HereCacheWriteResponseSchema, fs as HereRoadGeomLayerNameSchema, gs as HereRoadGeomMetaSchema, bs as HereRoadGeomRowSchema, ws as HereRoadGeomTileSchema, _s as HereSpeedLimitRowSchema, us as HereSpeedLimitsCondLayerNameSchema, ms as HereSpeedLimitsCondMetaSchema, vs as HereSpeedLimitsCondRowSchema, Ss as HereSpeedLimitsCondTileSchema, ls as HereSpeedLimitsLayerNameSchema, ps as HereSpeedLimitsMetaSchema, xs as HereSpeedLimitsTileSchema, ds as HereSpeedLimitsVarLayerNameSchema, hs as HereSpeedLimitsVarMetaSchema, ys as HereSpeedLimitsVarRowSchema, Cs as HereSpeedLimitsVarTileSchema, cs as HereTileMetaBaseSchema, Os as HereTileSchema, wc as LSV_MAX_SPEED_MPH, vc as MAP_TILES_VERSION, yc as MAP_TILE_SIZE_PX, _c as MAP_TILE_VERSION, Bc as METRICS_NAMESPACE, Cc as ROAD_OVERLAY_HIGH_SPEED_COLOR, Sc as ROAD_OVERLAY_LOW_SPEED_COLOR, bc as ROAD_OVERLAY_TILE_PATH_PREFIX, Tc as VEHICLE_TOP_SPEED_MPH, xc as WEB_MERCATOR_MAX_LATITUDE, mc as canonicalJson, Ac as clampWebMercatorLatitude, Vc as emitMetrics, zc as expandBBox, Jc as filterNulls, qc as filterNullsDefaultWithEmpty, Dc as firstPresentSpeedLimit, $e as fmtDt, kc as getMapTileCountForZoom, Mc as getMapTilesPath, Nc as getMapTilesUrl, Ls as getTilesForBBox, nt as haversineMeters, Uc as instrumentHereRequest, Fc as latLngToGlobalPixel, Pc as latLngToTileCoordinate, Ic as latLngToTilePixel, Rc as mapTileCoordinateToBBox, rt as nearestPointOnSegment, d as newGqlError, Ec as normalizeHereSpeedLimitToMph, jc as normalizeMapTileCoordinate, Kc as notNullish, Gc as numberToPaddedUUID, gc as sha256Hex, Wc as sleep, Hc as startTimer, Qe as subDays, Rs as tileCacheKey, As as tileIsRoadGeomTile, js as tileIsSpeedLimitTile, Yc as typedFromEntries, Xc as typedGroupsFromEntries, hc as utf8ByteLength };

//# sourceMappingURL=index.js.map